{
	"dialog.ok": "OK",
	"dialog.cancel": "Anuluj",
	"dialog.confirm": "Potwierdź",
	"dialog.close": "Zamknij",
	"dialog.import": "Importuj",
	"dialog.save": "Zapisz",
	"dialog.discard": "Odrzuć",
	"dialog.dontshowagain": "Nie pokazuj ponownie",
	"data.cube": "Kostka",
	"data.group": "Grupa",
	"data.texture": "Tekstura",
	"data.plugin": "Plugin",
	"data.preview": "Podgląd",
	"data.toolbar": "Pasek narzędzi",
	"data.image": "Obraz",
	"keys.ctrl": "Ctrl",
	"keys.shift": "Shift",
	"keys.alt": "Alt",
	"keys.meta": "Cmd",
	"keys.delete": "Usuń",
	"keys.space": "Spacja",
	"keys.leftclick": "Lewy przycisk myszy",
	"keys.middleclick": "Środkowy przycisk myszy",
	"keys.rightclick": "Prawy przycisk myszy",
	"keys.tab": "Tab",
	"keys.backspace": "Backspace",
	"keys.enter": "Enter",
	"keys.escape": "Escape",
	"keys.function": "F%0",
	"keys.numpad": "Num %0",
	"keys.caps": "Capslock",
	"keys.menu": "Menu kontekstowe",
	"keys.left": "Lewo",
	"keys.up": "Góra",
	"keys.right": "Prawo",
	"keys.down": "Dół",
	"keys.pageup": "Page Up",
	"keys.pagedown": "Page Down",
	"keys.plus": "Plus",
	"keys.comma": "Przecinek",
	"keys.point": "Kropka",
	"keys.minus": "Minus",
	"keys.cross": "Krzyżyk",
	"keys.end": "Koniec",
	"keys.pos1": "Pozycja 1",
	"keys.printscreen": "Print Screen",
	"keys.pause": "Pauza",
	"message.rotation_limit.title": "Ograniczenia rotacji",
	"message.rotation_limit.message": "Rotacje są ograniczone do jednej osi i wielokrotności 22,5 stopni przez Minecraft. Obracanie na innej osi zresetuje obroty na innych osiach. Przekonwertuj model na \"Model ogólny\" jeśli modelujesz do innych programów niż Minecraft i potrzebujesz rozszerzonych opcji rotacji",
	"message.file_not_found.title": "Nie znaleziono pliku",
	"message.file_not_found.message": "Blockbench nie mógł odnaleźć pliku. Upewnij się że jest zapisany lokalnie, a nie w chmurze.",
	"message.screenshot.title": "Zrzut ekranu",
	"message.screenshot.clipboard": "Schowek",
	"message.screenshot.right_click": "Zrzut ekranu - kliknij prawym przyciskiem myszy aby skopiować",
	"message.invalid_file.title": "Nieprawidłowy plik",
	"message.invalid_file.message": "Nie udało się otworzyć pliku modelu: %0",
	"message.invalid_model.title": "Nieprawidłowy plik modelu",
	"message.invalid_model.message": "Ten plik nie zawiera prawidłowych danych modelu.",
	"message.child_model_only.title": "Pusty model dziecka",
	"message.child_model_only.message": "Ten plik jest dzieckiem %0 i nie zawiera modelu.",
	"message.unsaved_textures.title": "Niezapisane tekstury",
	"message.unsaved_textures.message": "Twój model ma niezapisane tekstury. Zapisz je i wstaw w odpowiedni folder w swoim resource packu.",
	"message.model_clipping.title": "Model zbyt duży",
	"message.model_clipping.message": "Twój model zawiera %0 kostek, które są większe niż limit 3x3x3 dozwalany przez Minecraft. Ten model nie będzie działał w Minecrafcie. Włącz opcję 'Ograniczony obszar roboczy' żeby temu zapobiec.",
	"message.loose_texture.title": "Import tekstur",
	"message.loose_texture.message": "Zaimportowana tekstura nie jest w paczce tekstur. Minecraft może załadować tylko tekstury z folderu textures z załadowanej paczki tekstur.",
	"message.loose_texture.change": "Zmień ścieżkę",
	"message.update_res.title": "Rozdzielczość tekstury",
	"message.update_res.message": "Czy chcesz zmienić rozdzielczość projektu do rozdzielczości tekstury? Kliknij 'Anuluj' jeżeli twoja tekstura ma większą rozdzielczość niż normalnie.",
	"message.update_res.update": "Aktualizuj",
	"message.bedrock_overwrite_error.message": "Blockbench nie może połączyć tego modelu ze starym plikiem",
	"message.bedrock_overwrite_error.backup_overwrite": "Stwórz kopię zapasową i nadpisz",
	"message.bedrock_overwrite_error.overwrite": "Nadpisz",
	"message.close_warning.message": "Czy chcesz zapisać swój model?",
	"message.close_warning.web": "Twoje niezapisane zmiany zostaną utracone. Jesteś pewien, że chcesz wyjść?",
	"message.default_textures.title": "Domyślne tekstury",
	"message.default_textures.message": "Wybierz folder \"textures\" w domyślnym resource packu",
	"message.default_textures.detail": "Wyciągnij domyślny resource pack z pliku .jar Minecrafta albo wygoogluj i ściągnij go. Potem, znajdź folder \"textures\" i otwórz go. Blockbench zapamięta to miejsce i weźmie stamtąd tekstury, jeżeli nie znajdzie ich w aktualnym resource packu.",
	"message.default_textures.select": "Wybierz domyślny folder \"textures\"",
	"message.image_editor.title": "Wybierz edytor obrazów",
	"message.image_editor.file": "Wybierz plik...",
	"message.image_editor.exe": "Wybierz .exe edytora obrazów",
	"message.display_skin.title": "Wyświetl skórkę",
	"message.display_skin.message": "Wybierz skórkę z komputera lub wpisz nazwę gracza",
	"message.display_skin.upload": "Prześlij skórkę",
	"message.display_skin.reset": "Resetuj",
	"message.invalid_plugin": "Nieprawidłowy plugin, sprawdź konsolę",
	"message.load_plugin_app": "Czy chcesz zezwolić temu pluginowi na dokonywanie zmian na twoim komputerze? Używaj tylko pluginów autorów, którym ufasz.",
	"message.load_plugin_web": "Czy chcesz załadować ten plugin? Używaj tylko pluginów osób, którym ufasz.",
	"message.preset_no_info": "Ten preset nie zawiera informacji dla tego slotu",
	"message.restart_to_update": "Otwórz Blockbench ponownie by zatwierdzić zmiany",
	"message.save_file": "Zapisano jako %0",
	"dialog.project.title": "Projekt",
	"dialog.project.name": "Nazwa pliku",
	"dialog.project.parent": "Model rodzica",
	"dialog.project.geoname": "Identyfikator modelu",
	"dialog.project.ao": "Ambient Occlusion",
	"dialog.texture.title": "Tekstura",
	"dialog.texture.variable": "Zmienna",
	"dialog.texture.namespace": "Przestrzeń nazw",
	"dialog.texture.folder": "Folder",
	"dialog.extrude.title": "Wytłocz obrazek",
	"dialog.extrude.mode": "Tryb skanowania",
	"dialog.extrude.mode.areas": "Pola",
	"dialog.extrude.mode.lines": "Linie",
	"dialog.extrude.mode.columns": "Kolumny",
	"dialog.extrude.mode.pixels": "Piksele",
	"dialog.extrude.opacity": "Minimalne krycie",
	"dialog.extrude.scan": "Skanuj i importuj",
	"dialog.display_preset.title": "Stwórz preset",
	"dialog.display_preset.message": "Wybierz sloty, które chcesz zapisać",
	"dialog.display_preset.create": "Stwórz",
	"dialog.select.title": "Wybierz",
	"dialog.select.group": "W zaznaczonej grupie",
	"dialog.select.name": "Nazwa zawiera",
	"dialog.select.random": "Losowy",
	"dialog.select.select": "Wybierz",
	"dialog.scale.title": "Skaluj model",
	"dialog.scale.axis": "Oś",
	"dialog.scale.clipping": "Ucięty model: twój model jest zbyt duży dla obszaru roboczego",
	"dialog.scale.confirm": "Skala",
	"dialog.plugins.title": "Pluginy",
	"dialog.plugins.installed": "Zainstalowane",
	"dialog.plugins.available": "Dostępne",
	"dialog.plugins.install": "Zainstaluj",
	"dialog.plugins.uninstall": "Odinstaluj",
	"dialog.plugins.reload": "Przeładuj",
	"dialog.plugins.none_installed": "Brak zainstalowanych pluginów",
	"dialog.plugins.none_available": "Brak dostępnych pluginów",
	"dialog.plugins.web_only": "Tylko dla wersji przeglądarkowej",
	"dialog.plugins.app_only": "Tylko dla aplikacji komputerowej",
	"dialog.plugins.author": "autorstwa %0",
	"dialog.create_texture.folder": "Folder",
	"dialog.create_texture.resolution": "Rozdzielczość",
	"dialog.input.title": "Wstaw",
	"dialog.settings.settings": "Ustawienia",
	"dialog.settings.keybinds": "Klawisze",
	"dialog.settings.about": "O programie",
	"layout.color.back": "Wstecz",
	"layout.color.back.desc": "Tła i pola wpisywania",
	"layout.color.dark": "Ciemny",
	"layout.color.dark.desc": "Tło obszaru roboczego",
	"layout.color.ui": "UI",
	"layout.color.ui.desc": "Główny kolor interfejsu",
	"layout.color.bright_ui": "Jasny interfejs",
	"layout.color.bright_ui.desc": "Menu kontekstowe i podpowiedzi",
	"layout.color.button": "Przycisk",
	"layout.color.button.desc": "Przyciski i przełączniki",
	"layout.color.selected": "Wybrany",
	"layout.color.selected.desc": "Wybrane zakładki i obiekty",
	"layout.color.border": "Ramki",
	"layout.color.border.desc": "Ramki przycisków i pól wpisywania",
	"layout.color.accent": "Akcent",
	"layout.color.accent.desc": "Gałki przełączników i inne detale",
	"layout.color.grid": "Siatka",
	"layout.color.grid.desc": "Siatka podglądu 3D",
	"layout.color.text": "Tekst",
	"layout.color.text.desc": "Normalny tekst",
	"layout.color.light": "Jasny",
	"layout.color.light.desc": "Zaznaczony tekst",
	"layout.color.accent_text": "Akcent tekstu",
	"layout.color.accent_text.desc": "Tekst na zaakcentowanych elementach",
	"layout.font.main": "Główna czcionka",
	"layout.font.headline": "Czcionka nagłówkowa",
	"about.version": "Wersja:",
	"settings.category.general": "Ogólne",
	"settings.category.preview": "Podgląd",
	"settings.category.grid": "Siatka",
	"settings.category.edit": "Edytuj",
	"settings.category.snapping": "Przyciąganie",
	"settings.category.defaults": "Wartości domyślne",
	"settings.category.dialogs": "Okienka dialogowe",
	"settings.category.export": "Eksportuj",
	"settings.language": "Język",
	"settings.language.desc": "Język interfejsu. Otwórz Blockbench ponownie, żeby zatwierdzić zmiany.",
	"settings.backup_interval": "Interwał kopii zapasowych",
	"settings.backup_interval.desc": "Interwał tworzenia automatycznych kopii zapasowych, w minutach",
	"settings.origin_size": "Punkt osi",
	"settings.origin_size.desc": "Rozmiar punktu osi",
	"settings.control_size": "Rozmiar kontroli osi",
	"settings.control_size.desc": "Rozmiar narzędzia do kontroli 3 osi",
	"settings.display_skin": "Wyświetlana skórka",
	"settings.display_skin.desc": "Skórka używana do wyświetlenia na referencyjnym modelu gracza",
	"settings.shading": "Cienie",
	"settings.shading.desc": "Włącz cienie w podglądzie",
	"settings.base_grid": "Mała siatka",
	"settings.base_grid.desc": "Pokaż małą siatkę i osie",
	"settings.large_grid": "Duża siatka",
	"settings.large_grid.desc": "Pokaż siatkę bloków 3x3",
	"settings.full_grid": "Pełna duża siatka",
	"settings.full_grid.desc": "Pokaż precyzyjną siatkę 3x3",
	"settings.large_box": "Duże pudełko",
	"settings.large_box.desc": "Pokaż granice bloków 3x3",
	"settings.display_grid": "Tryb wyświetlania",
	"settings.display_grid.desc": "Pokaż siatkę w trybie wyświetlania",
	"settings.undo_limit": "Limit kroków wstecz",
	"settings.undo_limit.desc": "Maksymalna liczba kroków wstecz",
	"settings.local_move": "Przesuwaj na osiach lokalnych",
	"settings.local_move.desc": "Przesuwaj elementy po ich własnych osiach, jeżeli jest to możliwe",
	"settings.canvas_unselect": "Kliknięcie w obszar roboczy odznacza",
	"settings.canvas_unselect.desc": "Odznacza wszystkie elementy kiedy obszar roboczy jest kliknięty",
	"settings.paint_side_restrict": "Ogranicz szczotkę do strony",
	"settings.paint_side_restrict.desc": "Ogranicz działanie szczotek aby tylko malować na aktualnej stronie",
	"settings.autouv": "Automatyczne UV",
	"settings.autouv.desc": "Domyślnie włącz automatyczne UV",
	"settings.create_rename": "Nazwij nową kostkę",
	"settings.create_rename.desc": "Wpisz nazwę po stworzeniu nowego elementu lub grupy",
	"settings.edit_size": "Rozdzielczość siatki",
	"settings.edit_size.desc": "Rozdzielczość siatki, do której przyciągane są kostki",
	"settings.shift_size": "Rozdzielczość shifta",
	"settings.shift_size.desc": "Rozdzielczość siatki gdy trzymany jest shift",
	"settings.ctrl_size": "Rozdzielczość ctrl",
	"settings.ctrl_size.desc": "Rozdzielczość siatki gdy trzymany jest ctrl",
	"settings.negative_size": "Ujemny rozmiar",
	"settings.negative_size.desc": "Pozwalaj narzędziu skalowania na używanie ujemnych rozmiarów",
	"settings.minifiedout": "Zminifikowany eksport",
	"settings.minifiedout.desc": "Wypisz plik JSON w jednej linii",
	"settings.export_groups": "Eksportuj grupy w model bloku/itemu Java",
	"settings.export_groups.desc": "Zapisuj grupy w plikach modeli bloków",
	"settings.credit": "Komentarz uznania",
	"settings.credit.desc": "Dodaj komentarz uznania do eksportowanych plików",
	"settings.default_path": "Domyślna ścieżka Minecraft'owych tekstur",
	"settings.default_path.desc": "Folder, z którego Blockbench ładuje domyślne tekstury",
	"settings.image_editor": "Edytor obrazów",
	"settings.image_editor.desc": "Domyślny edytor obrazów do edytowania tekstur",
	"category.navigate": "Nawigacja",
	"category.tools": "Narzędzia",
	"category.file": "Plik",
	"category.blockbench": "Blockbench",
	"category.edit": "Edycja",
	"category.transform": "Przesuwanie",
	"category.view": "Widok",
	"category.display": "Ustawienia wyglądu",
	"category.textures": "Tekstury",
	"category.misc": "Inne",
	"keybind.preview_select": "Wybierz",
	"keybind.preview_rotate": "Obróć widok",
	"keybind.preview_drag": "Przenieś widok",
	"keybind.confirm": "Potwierdź",
	"keybind.cancel": "Anuluj",
	"action.slider_inflate": "Nadmuchaj",
	"action.slider_inflate.desc": "Nadmuchaj kostki we wszystkich kierunkach, bez zmieniania UV.",
	"action.slider_brush_size": "Wielkość",
	"action.slider_brush_size.desc": "Promień pędzla w pikselach",
	"action.slider_brush_opacity": "Nieprzezroczystość",
	"action.slider_brush_opacity.desc": "Nieprzezroczystość pędzla w procentach",
	"action.slider_brush_softness": "Miękkość",
	"action.slider_brush_softness.desc": "Miękkość pędzla w procentach",
	"action.uv_slider_pos_x": "Przesuń w poziomie",
	"action.uv_slider_pos_x.desc": "Przesuń zaznaczenie UV wszystkich zaznaczonych kostek w poziomie",
	"action.uv_slider_pos_y": "Przesuń w pionie",
	"action.uv_slider_pos_y.desc": "Przesuń pionowy wybór UV wszystkich zaznaczonych kostek",
	"action.uv_slider_size_x": "Skaluj poziomo",
	"action.uv_slider_size_x.desc": "Skaluj zaznaczenie UV wszystkich zaznaczonych kostek w poziomie",
	"action.uv_slider_size_y": "Skaluj w pionie",
	"action.uv_slider_size_y.desc": "Skaluj zaznaczenie UV wszystkich zaznaczonych kostek w pionie",
	"action.vertex_snap_mode": "Tryb przyciągania",
	"action.vertex_snap_mode.desc": "Wybierz czy przyciąganie wierzchołków ma przesuwać elementy czy zmieniać ich rozmiar",
	"action.move_tool": "Przesuń",
	"action.move_tool.desc": "Narzędzie do wybierania i przesuwania elementów",
	"action.resize_tool": "Zmień rozmiar",
	"action.resize_tool.desc": "Narzędzie do wybierania i zmieniania rozmiaru elementów",
	"action.brush_tool": "Pędzel",
	"action.brush_tool.desc": "Narzędzie do malowania na teksturach bitmapowych na powierzniach lub w edytorze UV.",
	"action.vertex_snap_tool": "Przyciąganie wierzchołków",
	"action.vertex_snap_tool.desc": "Przesuń jedną kostkę do innej przez połączenie dwóch wierzchołków.",
	"action.swap_tools": "Przełącz narzędzia",
	"action.swap_tools.desc": "Przełącz się pomiędzy narzędziem przesuwania i zmiany rozmiaru",
	"action.project_window": "Projekt...",
	"action.project_window.desc": "Otwiera okienko projektu, gdzie możesz edytować metadatę twojego modelu",
	"action.open_model": "Otwórz model",
	"action.open_model.desc": "Otwórz plik modelu z komputera",
	"action.extrude_texture": "Wyciągnięta tekstura",
	"action.extrude_texture.desc": "Generuj model przez rozciągnięcie tekstury",
	"action.export_blockmodel": "Eksportuj model bloku/itemu",
	"action.export_blockmodel.desc": "Eksportuj model bloku lub przedmiotu Minecraft Java Edition",
	"action.export_optifine_part": "Eksportuj część OptiFine",
	"action.export_optifine_part.desc": "Eksportuj pojedyńczą część dla modelu bytu OptiFine",
	"action.export_optifine_full": "Eksportuj JEM OptiFine",
	"action.export_optifine_full.desc": "Eksportuj cały model bytu OptiFine",
	"action.export_obj": "Eksportuj model OBJ",
	"action.export_obj.desc": "Eksportuj model Wavefront OBJ dla renderowania",
	"action.settings_window": "Ustawienia...",
	"action.settings_window.desc": "Otwórz okienko ustawień Blockbench",
	"action.plugins_window": "Pluginy...",
	"action.plugins_window.desc": "Otwórz okienko sklepu z pluginami",
	"action.reset_layout": "Resetuj układ",
	"action.reset_layout.desc": "Resetuj układ do domyślnego w Blockbench",
	"action.load_plugin": "Załaduj plugin z pliku",
	"action.load_plugin.desc": "Załaduj plugin z pliku źródłowego",
	"action.reload_plugins": "Przeładuj pluginy",
	"action.reload_plugins.desc": "Przeładowuje wszystkie pluginy deweloperskie",
	"action.undo": "Cofnij",
	"action.undo.desc": "Odwraca ostatnią zmianę",
	"action.redo": "Ponów",
	"action.redo.desc": "Ponawia ostatnie cofnięcie",
	"action.copy": "Kopiuj",
	"action.copy.desc": "Kopiuj zaznaczenie, ścianę lub ustawienia wyświetlania",
	"action.paste": "Wklej",
	"action.paste.desc": "Wklej zaznaczenie, ścianę lub ustawienia wyświetlania",
	"action.cut": "Wytnij",
	"action.cut.desc": "Wytnij zaznaczenie, ścianę lub ustawienia wyświetlania",
	"action.add_cube": "Dodaj kostkę",
	"action.add_cube.desc": "Dodaje nową kostkę",
	"action.add_group": "Dodaj grupę",
	"action.add_group.desc": "Dodaje nową grupę lub kość",
	"action.outliner_toggle": "Przełącz więcej opcji",
	"action.outliner_toggle.desc": "Pokazuje więcej opcji w outlinerze",
	"action.duplicate": "Duplikuj",
	"action.delete": "Usuń",
	"action.sort_outliner": "Sortuj outliner",
	"action.sort_outliner.desc": "Sortuj outliner alfabetycznie",
	"action.select_window": "Wybierz...",
	"action.select_window.desc": "Wyszukaj i wybierz kostki ze względu na ich własności",
	"action.invert_selection": "Odwróć zaznaczenie",
	"action.invert_selection.desc": "Odwróć aktualnie zaznaczone kostki",
	"action.select_all": "Wybierz wszystko",
	"action.collapse_groups": "Zwiń grupy",
	"action.collapse_groups.desc": "Zwiń wszystkie grupy w outlinerze",
	"action.scale": "Skaluj",
	"action.scale.desc": "Skaluj zaznaczone kostki",
	"action.toggle_visibility": "Przełącz widoczność",
	"action.toggle_visibility.desc": "Przełącz widoczność zaznaczonych kostek.",
	"action.toggle_export": "Przełącz eksportowanie",
	"action.toggle_export.desc": "Przełącz ustawienia eksportowania zaznaczonych kostek.",
	"action.toggle_autouv": "Przełącz automatyczne UV",
	"action.toggle_autouv.desc": "Przełącz ustawienie automatycznego UV dla zaznaczonych kostek.",
	"action.toggle_shade": "Przełącz cienie",
	"action.toggle_shade.desc": "Przełącz cienie zaznaczonych kostek",
	"action.rename": "Zmień nazwę",
	"action.rename.desc": "Zmień nazwę zaznaczonych kostek.",
	"action.add_display_preset": "Nowy preset",
	"action.add_display_preset.desc": "Dodaj nowy preset ustawień widoku",
	"action.fullscreen": "Pełny ekran",
	"action.fullscreen.desc": "Przełącza tryb pełnego ekranu.",
	"action.zoom_in": "Przybliż",
	"action.zoom_in.desc": "Przybliż aby powiększyć interfejs.",
	"action.zoom_out": "Oddal",
	"action.zoom_out.desc": "Oddal aby zmniejszyć interfejs.",
	"action.zoom_reset": "Resetuj powiększenie",
	"action.zoom_reset.desc": "Resetuj powiększenie do domyślnych 100%",
	"action.reset_interface": "Resetuj interfejs",
	"action.reset_interface.desc": "Resetuj rozmiar i pozycje GUI",
	"action.screenshot_model": "Zrzut ekranu modelu",
	"action.screenshot_model.desc": "Wykonaj przyciętyu zrzut ekranu modelu z aktualnego kąta",
	"action.screenshot_app": "Zrzut ekranu programu",
	"action.screenshot_app.desc": "Wykonaj zrzut ekranu całej aplikacji",
	"action.import_texture": "Importuj teksturę",
	"action.import_texture.desc": "Zaimportuj jedną lub więcej tekstur z komputera",
	"action.create_texture": "Stwórz teksturę",
	"action.create_texture.desc": "Stwórz czystą teksturę lub szablon tekstury",
	"action.save_textures": "Zapisz tekstury",
	"action.save_textures.desc": "Zapisz wszystkie niezapisane tekstury",
	"action.animated_textures": "Odtwarzaj animowane tekstury",
	"action.animated_textures.desc": "Odtwarzaj i pauzuj animowane tekstury",
	"action.origin_to_geometry": "Punkt obrotu do geometrii",
	"action.origin_to_geometry.desc": "Ustal punkt osi w środku zaznaczenia",
	"action.bone_reset_toggle": "Resetuj kość",
	"action.bone_reset_toggle.desc": "Kość nie będzie wyświetlać kostek z modelu rodzica",
	"action.reload": "Przeładuj Blockbench",
	"action.reload.desc": "Przeładuj Blockbench. To usunie wszystkie niezapisane postępy.",
	"menu.file": "Plik",
	"menu.edit": "Edycja",
	"menu.transform": "Przesuń",
	"menu.display": "Wyświetlanie",
	"menu.view": "Widok",
	"menu.file.new": "Nowy",
	"menu.file.recent": "Ostatnio",
	"menu.file.import": "Import",
	"menu.file.export": "Eksport",
	"menu.transform.rotate": "Obróć",
	"menu.transform.flip": "Odwróć",
	"menu.transform.center": "Wyśrodkuj",
	"menu.transform.properties": "Właściwości",
	"menu.display.preset": "Zastosuj preset",
	"menu.display.preset_all": "Zastosuj preset wszędzie",
	"menu.display.remove_preset": "Usuń Preset",
	"menu.view.zoom": "Powiększenie",
	"menu.view.background": "Tło",
	"menu.view.screenshot": "Zrzut ekranu",
	"menu.cube.color": "Kolor znacznika",
	"menu.cube.texture": "Tekstura",
	"menu.cube.texture.transparent": "Przezroczysta",
	"menu.cube.texture.blank": "Pusta",
	"menu.group.sort": "Sortuj",
	"menu.texture.face": "Zastosuj do ściany",
	"menu.texture.file": "Plik",
	"menu.texture.refresh": "Odśwież",
	"menu.texture.change": "Zmień plik",
	"menu.texture.folder": "Otwórz w folderze",
	"menu.texture.edit": "Edytuj",
	"menu.texture.export": "Zapisz jako",
	"menu.texture.save": "Zapisz",
	"menu.texture.properties": "Właściwości",
	"menu.preview.background": "Tło",
	"menu.preview.background.load": "Załaduj",
	"menu.preview.background.position": "Pozycja",
	"menu.preview.background.lock": "Zablokuj do kamery",
	"menu.preview.screenshot": "Zrzut ekranu",
	"menu.preview.perspective": "Perspektywa",
	"menu.preview.perspective.normal": "Normalna",
	"menu.preview.quadview": "Widok Quad",
	"menu.preview.stop_drag": "Skończ pozycjonowanie tła",
	"menu.uv.mapping.rotation": "Rotacja",
	"menu.uv.texture": "Tekstura",
	"cube.color.light_blue": "Jasnoniebieski",
	"cube.color.yellow": "Żółty",
	"cube.color.orange": "Pomarańczowy",
	"cube.color.red": "Czerwony",
	"cube.color.purple": "Fioletowy",
	"cube.color.blue": "Niebieski",
	"cube.color.green": "Zielony",
	"cube.color.lime": "Limonkowy",
	"switches.visibility": "Widoczność",
	"switches.export": "Eksport",
	"switches.autouv": "Automatyczne UV",
	"panel.uv": "UV",
	"panel.display": "Wyświetlanie",
	"panel.textures": "Tekstury",
	"panel.outliner": "Outliner",
	"uv_editor.title": "Edytor UV",
	"uv_editor.all_faces": "Wszystkie",
	"uv_editor.no_faces": "Żadne",
	"face.north": "Północ",
	"face.south": "Południe",
	"face.west": "Zachód",
	"face.east": "Wschód",
	"face.up": "Góra",
	"face.down": "Dół",
	"direction.north": "Północ",
	"direction.south": "Południe",
	"direction.west": "Zachód",
	"direction.east": "Wschód",
	"direction.top": "Góra",
	"direction.bottom": "Dół",
	"display.slot.third_right": "Trzecioosobowa Prawa",
	"display.slot.third_left": "Trzecioosobowa Lewa",
	"display.slot.first_right": "Pierwszoosobowa Prawa",
	"display.slot.first_left": "Pierwszoosobowa Lewa",
	"display.slot.head": "Głowa",
	"display.slot.ground": "Podłoże",
	"display.slot.frame": "Ramka",
	"display.slot.gui": "GUI",
	"display.rotation": "Rotacja",
	"display.translation": "Transpozycja",
	"display.scale": "Skala",
	"display.slot": "Slot",
	"display.reference": "Model referencyjny",
	"display.reference.player": "Gracz",
	"display.reference.zombie": "Zombie",
	"display.reference.armor_stand": "Stojak na zbroje",
	"display.reference.baby_zombie": "Zombie dziecko",
	"display.reference.armor_stand_small": "Mały stojak na zbroje",
	"display.reference.monitor": "Normalny",
	"display.reference.bow": "Łuk",
	"display.reference.block": "Blok",
	"display.reference.frame": "Ramka na przedmiot",
	"display.reference.inventory_nine": "3x3",
	"display.reference.inventory_full": "Ekwipunek",
	"display.reference.hud": "HUD",
	"display.preset.blank_name": "Proszę podać nazwę",
	"display.preset.item": "Podstawowy Przedmiot",
	"display.preset.block": "Podstawowy blok",
	"display.preset.handheld": "Podstawowa broń",
	"display.preset.rod": "Podstawowa róźdżka",
	"dialog.continue": "Kontynuuj",
	"message.square_textures": "Tekstury muszą być kwadratowe",
	"message.unsaved_texture.title": "Niezapisana tekstura",
	"message.unsaved_texture.message": "Wszystkie niezapisane zmiany tej tekstury zostaną utracone. Chcesz kontynuować?",
	"action.vertex_snap_mode.move": "Przesuń",
	"action.vertex_snap_mode.scale": "Skaluj",
	"action.open_model_folder": "Otwórz folder modelu",
	"action.open_model_folder.desc": "Otwiera folder, w którym znajduje się model",
	"action.change_textures_folder": "Zmień lokalizacje tekstur",
	"action.change_textures_folder.desc": "Zmienia katalog, w którym są zapisane wszystkie tekstury",
	"menu.texture.particle": "Użyj dla cząstek",
	"message.update_notification.title": "Nie można zainstalować aktualizacji",
	"message.update_notification.message": "Nowa wersja Blockbench \"%0\" jest dostępna. Chcesz ją teraz zainstalować?",
	"message.untextured": "Ta powierzchnia nie ma tekstury",
	"dialog.toolbar_edit.title": "Dostosuj pasek z narzędziami",
	"keybindings.reset": "Resetuj",
	"keybindings.clear": "Pusty",
	"action.cube_counter": "Licznik kostek",
	"action.uv_rotation": "Obrót UV",
	"action.uv_rotation.desc": "Obrót UV ściany",
	"action.uv_grid": "Siatka UV",
	"action.uv_grid.desc": "Rozdzielczość siatki, do której selektor UV się przyciąga",
	"action.uv_grid.auto": "Auto",
	"action.uv_maximize": "Maksymalizuj UV",
	"action.uv_maximize.desc": "Ustala UV tej ściany na całą teksturę",
	"action.uv_auto": "Automatyczne UV",
	"action.uv_auto.desc": "Ustala UV tej ściany na prawdziwy rozmiar ściany",
	"action.uv_rel_auto": "Względne Automatyczne UV",
	"action.uv_rel_auto.desc": "Ustala UV tej ściany do pozycji i wielkośći ściany",
	"action.uv_mirror_x": "Odbij X UV",
	"action.uv_mirror_x.desc": "Odbija UV tej ściany na osi X",
	"action.uv_mirror_y": "Odbij Y UV",
	"action.uv_mirror_y.desc": "Odbija UV tej ściany na osi Y",
	"action.uv_transparent": "Przezroczysta ściana",
	"action.uv_transparent.desc": "Ustawia wybraną ścianę na przezroczystą",
	"action.uv_reset": "Resetuj ścianę",
	"action.uv_reset.desc": "Resetuje wybraną ścianę",
	"action.cullface": "Cullface",
	"action.cullface.desc": "Nie renderuje tej ściany jeżeli wybrana strona modelu jest zakryta",
	"action.auto_cullface": "Auto Cullface",
	"action.auto_cullface.desc": "Ustala cullface tej ściany do siebie",
	"action.face_tint": "Odcień",
	"action.face_tint.desc": "Pozwala na ustalenie odcienia dla wybranej ściany",
	"menu.toolbar.edit": "Dostosuj",
	"menu.toolbar.reset": "Resetuj",
	"uv_editor.rotated": "Obrócone",
	"uv_editor.auto_cull": "Cullface do siebie",
	"uv_editor.copied": "Skopiowana ściana",
	"uv_editor.pasted": "Wklejona ściana",
	"uv_editor.copied_x": "Skopiowano %0 ścian",
	"uv_editor.reset": "Resetuj ścianę",
	"uv_editor.maximized": "Maksymalizowane",
	"uv_editor.autouv": "Auto rozmiar",
	"uv_editor.mirrored": "Odbito",
	"uv_editor.to_all": "Zastosowano do wszystkich ścian",
	"uv_editor.transparent": "Zrobiono przezroczyste",
	"uv_editor.cullface_on": "Cullface włączony",
	"uv_editor.cullface_off": "Cullface wyłączony",
	"uv_editor.tint_on": "Odcień włączony",
	"uv_editor.tint_off": "Odcień wyłączony",
	"action.uv_apply_all": "Zastosuj do wszystkich ścian",
	"action.uv_apply_all.desc": "Stosuje ustawienia wybranej ściany do wszystkich ",
	"message.image_editor_missing.title": "Domyślny edytor obrazów",
	"message.image_editor_missing.message": "Wybierz plik exe twojego edytora obrazów.",
	"message.image_editor_missing.detail": "Blockbench nie mógł odnaleźć edytora obrazów na twoim komputerze. Wybierz plik exe twojego preferowanego edytora obrazów.",
	"action.update_autouv": "Aktualizuj auto UV",
	"action.update_autouv.desc": "Aktualizuj automatyczne mapowanie UV zaznaczonych kostek",
	"category.uv": "UV",
	"status_bar.saved": "Model jest zapisany",
	"status_bar.unsaved": "Istnieją niezapisane zmiany",
	"action.move_up": "Przesuń w górę",
	"action.move_up.desc": "Przesuń zaznaczone kostki w górę, względem aktualnego kąta kamery",
	"action.move_down": "Przesuń w dół",
	"action.move_down.desc": "Przesuń zaznaczone kostki w dół, względem aktualnego kąta kamery",
	"action.move_left": "Przesuń w lewo",
	"action.move_left.desc": "Przesuń zaznaczone kostki w lewo, względem aktualnego kąta kamery",
	"action.move_right": "Przesuń w prawo",
	"action.move_right.desc": "Przesuń zaznaczone kostki w prawo, względem aktualnego kąta kamery",
	"action.move_forth": "Przesuń do przódu",
	"action.move_forth.desc": "Przesuń zaznaczone kostki do przodu, względem aktualnego kąta kamery",
	"action.move_back": "Przesuń do tyłu",
	"action.move_back.desc": "Przesuń zaznaczone kostki do tyłu, względem aktualnego kąta kamery",
	"layout.color.wireframe": "Szkielet",
	"layout.color.wireframe.desc": "Widok linii szkieletów",
	"action.add_animation": "Dodaj animację",
	"action.add_animation.desc": "Stwórz pustą animację",
	"action.load_animation_file": "Importuj animacje",
	"action.load_animation_file.desc": "Importuj plik animacji",
	"action.play_animation": "Odtwórz animacje",
	"action.play_animation.desc": "Obejrzyj zaznaczoną animację",
	"action.slider_keyframe_time": "Czas",
	"action.slider_keyframe_time.desc": "Zmień czas zaznaczonych klatek",
	"timeline.rotation": "Rotacja",
	"timeline.position": "Pozycja",
	"timeline.scale": "Rozmiar",
	"menu.keyframe.quaternion": "Kwaternion",
	"panel.animations": "Animacje",
	"panel.keyframe": "Klatka kluczowa",
	"panel.keyframe.type": "Klatka kluczowa (%0)",
	"generic.delete": "Usuń",
	"generic.rename": "Zmień nazwę",
	"message.no_animation_selected": "Musisz wybrać animację żeby to zrobić",
	"message.no_bone_selected": "Musisz wybrać kość żeby to zrobić",
	"message.duplicate_groups.title": "Duplikat nazwy kości",
	"message.duplicate_groups.message": "Nazwa tej kości istnieje na wielu kościach. To moze sprawić problemy.",
	"action.delete_keyframes": "Usuń klatki kluczowe",
	"action.delete_keyframes.desc": "Usuń wszystkie zaznaczone klatki kluczowe",
	"menu.animation": "Animacja",
	"menu.animation.loop": "Zapętl",
	"menu.animation.override": "Nadpisz",
	"menu.animation.anim_time_update": "Aktualizuj zmienną",
	"message.display_skin_model.title": "Model skina",
	"message.display_skin_model.message": "Zmień typ modelu skina",
	"message.display_skin_model.classic": "Klasyczny",
	"message.display_skin_model.slim": "Slim",
	"message.bone_material": "Zmień materiał kości",
	"action.slider_animation_length": "Długość animacji",
	"action.slider_animation_length.desc": "Zmień długość zaznaczonej animacji",
	"panel.variable_placeholders": "\n Zmienne symbole zastępcze",
	"panel.variable_placeholders.info": " Wymień zmienne, które chcesz podglądnąć za pomocą nazwy = wartość",
	"status_bar.vertex_distance": "Odległość: 0%",
	"dialog.create_gif.title": "Zapisz GIF",
	"dialog.create_gif.length": "Długość",
	"dialog.create_gif.fps": "FPS",
	"dialog.create_gif.play": "Rozpocznij animację",
	"category.animation": "Animacja",
	"action.record_model_gif": "Zapisz GIF",
	"action.record_model_gif.desc": "￼\n Nagraj animowany GIF modelu z bieżącego kąta",
	"display.mirror": "Lustro",
	"data.separator": "Separator",
	"menu.preview.background.set_position": "Ustaw pozycję",
	"dialog.toolbar_edit.hidden": "￼\n Ukryty",
	"action.export_class_entity": "Eksportuj byt Java",
	"action.export_class_entity.desc": "￼Wyeksportuj model bytu jako klasę Java",
	"settings.seethrough_outline": "Kontury X-Ray",
	"settings.seethrough_outline.desc": "Pokaż kontury przez obiekty",
	"mode.edit": "Edytuj",
	"mode.paint": "Maluj",
	"mode.display": "Ekspozycja",
	"mode.animate": "Animuj",
	"status_bar.recording_gif": "Nagrywanie GIF",
	"status_bar.processing_gif": "Przetwarzanie GIF",
	"settings.backup_retain": "Czas podtrzymania kopii zapasowej",
	"settings.backup_retain.desc": "Ustaw jak długo Blockbench zachowuje stare kopie zapasowe w dniach",
	"action.rotate_tool": "Narzędzie oobracania",
	"action.rotate_tool.desc": "￼Narzędzie do wybierania i obracania elementów",
	"action.fill_tool": "Wiaderko farby",
	"action.fill_tool.desc": "Wiaderko farby zalewa maluje obszar na jeden kolor",
	"action.eraser": "Gumka",
	"action.eraser.desc": "Gumka zastępuje teksturę przeżroczystością",
	"action.color_picker": "Próbnik koloru",
	"action.color_picker.desc": "Narzędzie do wyboru koloru pikseli na teksturze",
	"switches.mirror": "Lustro UV",
	"language_name": "Angielski",
	"message.plugin_reload": "Przeładowano %0 lokalnych pluginów",
	"settings.brightness": "Jasność",
	"settings.brightness.desc": "Jasność podglądu. Domyślnie 50.",
	"menu.preview.perspective.reset": "Zresetuj kamerę",
	"action.fill_mode": "Tryb wypełniania",
	"action.fill_mode.face": "Przód",
	"action.fill_mode.color": "Kolory",
	"action.toggle_mirror_uv": "Odbicie UV",
	"action.toggle_mirror_uv.desc": "Przełącz odbicie lustrzane UV na osi X wybranych kostek",
	"menu.texture.blank": "Stosuj na ścianę bez tekstury",
	"dialog.scale.select_overflow": "Select Overflow",
	"action.action_control": "Kontroler akcji",
	"action.action_control.desc": "Wyszukaj i wykonaj każdą dostępną akcję",
	"keybindings.recording": "Nagrywanie skrótów klawiszowych",
	"keybindings.press": "Naciśnij klawisz lub kombinację klawiszy albo kliknij w dowolnym miejscu na ekranie, aby nagrać swoje skojarzenie klawiszy.",
	"action.pivot_tool": "Narzędzie punktu osi",
	"action.pivot_tool.desc": "Narzędzie do zmiany punktu osi kostek i kości",
	"action.slider_animation_speed": "Szybkość Odtwarzania",
	"action.slider_animation_speed.desc": "Prędkość odtwarzania osi czasu w procentach",
	"action.previous_keyframe": "Poprzednia klatka kluczowa",
	"action.previous_keyframe.desc": "Skocz do poprzedniej klatki kluczowej",
	"action.next_keyframe": "Następna klatka kluczowa",
	"action.next_keyframe.desc": "Skocz do następnej klatki kluczowej",
	"message.outdated_client.title": "Przestarzały klient",
	"message.outdated_client.message": "Zaktualizuj blockbencha do nowszej wersji żeby to zrobić!",
	"action.export_asset_archive": "Pobier Archiv",
	"action.export_asset_archive.desc": "Pobierz archiwum z modelem i wszystkimi teksturami.",
	"action.upload_sketchfab": "Prześlij na Sketchfab",
	"message.sketchfab.name_or_token": "Wpisz Twój token Sketchfab i nazwę",
	"dialog.sketchfab_uploader.title": "Prześlij model Sketchfab",
	"dialog.sketchfab_uploader.token": "Token API",
	"dialog.sketchfab_uploader.about_token": "Token jest używany do łączenia Blockbencha z Twoim kontem Sketchfab. Możesz go znaleźć na stronie %0",
	"dialog.sketchfab_uploader.name": "Nazwa modelu",
	"dialog.sketchfab_uploader.description": "Opis",
	"dialog.sketchfab_uploader.tags": "Tagi",
	"settings.sketchfab_token": "Sketchfab Token",
	"settings.sketchfab_token.desc": "Token upoważniający Blockbench do przesyłania danych na Twoje konto Sketchfab",
	"panel.color": "Kolor",
	"data.origin": "Punkt osi",
	"message.sketchfab.success": "Model został wysłany",
	"message.sketchfab.error": "Wystąpił problem podczas udostępniania modelu na Sketchfab",
	"settings.outliner_colors": "Kolory outlinera",
	"settings.outliner_colors.desc": "Wyświetlaj kolory elementów i grup w outlinerze",
	"action.upload_sketchfab.desc": "Udostępnij model na Sketchfab",
	"action.element_colors": "Kolory kostki",
	"action.element_colors.desc": "Pokaż kolory kostek w outlinerze",
	"texture.error.file": "Plik nieznaleziony",
	"texture.error.parent": "Plik tekstury dostarczony przez model rodzica",
	"message.recover_backup.title": "Odzyskaj model",
	"message.recover_backup.message": "Blockbench został zamknięty bez zapisywania. Czy chcesz odzyskać model?",
	"message.invalid_session.title": "Nieprawidłowy Token Sesji",
	"message.invalid_session.message": "Sesja, do której próbujesz się przyłączyć wygasła lub podany token jest nieprawidłowy.",
	"dialog.create_texture.power": "Power-of-2 Size",
	"dialog.create_gif.turn": "Turntable Speed",
	"action.edit_session": "Edytuj Sesję...",
	"action.edit_session.desc": "Połącz się z sesją edycji, aby współpracować z innymi użytkownikami",
	"action.reset_keyframe": "Resetuj klatkę kluczową",
	"action.reset_keyframe.desc": "Zresetuj wszystkie wartości wybranych klatek kluczowych",
	"dialog.edit_session.title": "Edytuj Sesję",
	"edit_session.username": "Nazwa użytkownika",
	"edit_session.token": "Token",
	"edit_session.about": "Sesje edycji mogą być używane do współpracy nad modelami przez internet. Utwórz sesję, skopiuj token i wyślij go do przyjaciół, którzy mogą następnie użyć go, aby dołączyć.",
	"edit_session.join": "Dołącz do sesji",
	"edit_session.create": "Stwórz sesję",
	"edit_session.quit": "Wyjdź z sesji",
	"edit_session.joined": "%0 dołączył do sesji",
	"edit_session.left": "%0 opuścił sesję",
	"edit_session.quit_session": "Opuść aktualną sesję",
	"edit_session.status": "Status",
	"edit_session.hosting": "Hosting",
	"edit_session.connected": "Połączono z sesją",
	"dialog.sketchfab_uploader.private": "Prywatne (Pro)",
	"dialog.sketchfab_uploader.password": "Hasło (Pro)",
	"action.uv_select_all": "Zaznacz wszystkie",
	"action.uv_select_all.desc": "Zaznacz wszystkie ściany w oknie dialogowym UV",
	"panel.chat": "Czat",
	"edit_session.welcome": "Welcome to this session by %0",
	"dialog.yes": "Tak",
	"dialog.no": "Nie",
	"generic.remove": "Usuń",
	"generic.download": "Pobierz",
	"generic.search": "Szukaj",
	"dates.today": "Dzisiaj",
	"dates.yesterday": "Wczoraj",
	"dates.this_week": "W tym tygodniu",
	"dates.weeks_ago": "%0 tygodni temu",
	"mode.start.new": "Nowy",
	"mode.start.recent": "Ostatnie",
	"format.free": "Model ogólny",
	"format.free.desc": "Model bez restrykcji. Dla silników gier, renderowania itd.",
	"format.java_block": "Java Blok/Przedmiot",
	"format.java_block.desc": "Model bloku na Java Edition. Rozmiar i kąty obrotu są ograniczone.",
	"format.bedrock": "Bedrock Model",
	"format.bedrock.desc": "Model na Bedrock Edition",
	"format.bedrock_old": "Bedrock Legacy Model",
	"format.bedrock_old.desc": "Model bytu sprzed 1.12 Minecraft Bedrock Edition",
	"format.modded_entity": "Zmodowany byt",
	"format.modded_entity.desc": "Model bytu do minecraftowych modów. Może być wyeksportowany jako klasowy plik .java",
	"format.optifine_entity": "Byt OptiFine",
	"format.optifine_entity.desc": "Własny model bytu dla OptiFine",
	"keys.mouse": "Przycisk myszy %0",
	"message.cleared_blank_faces.title": "Puste ściany",
	"message.cleared_blank_faces.message": "Blockbench znalazł %0 kostek bez żadnej tekstury. Czy chcesz usunąć te elementy?",
	"message.wireframe.enabled": "Widok szkieletu włączony",
	"message.wireframe.disabled": "Widok szkieletu wyłączony",
	"dialog.convert_project.title": "Konwertuj Projekt",
	"dialog.create_texture.double_use": "Keep Multi Texture Occupancy",
	"dialog.model_stats.title": "Statystyki modelu",
	"dialog.model_stats.cubes": "Kostki",
	"dialog.model_stats.locators": "Lokalizator",
	"dialog.model_stats.groups": "Grupy",
	"dialog.model_stats.vertices": "Wierzchołki",
	"dialog.model_stats.faces": "Powierzchnie",
	"settings.username": "Nazwa użytkownika",
	"settings.username.desc": "Nazwa użytkownika dla sesji edycji",
	"settings.painting_grid": "Siatka malarska",
	"settings.painting_grid.desc": "Pokaż siatkę na oteksturowanych kostkach w trybie malowania",
	"action.convert_project": "Konwertuj projekt",
	"action.convert_project.desc": "Konwertuje bieżący projekt na projekt dla innego formatu modelu",
	"action.close_project": "Zamknij projekt",
	"action.close_project.desc": "Zamyka aktualnie otworzony projekt",
	"action.export_bedrock": "Eksportuj bedrockową geometrię",
	"action.export_bedrock.desc": "Wyeksportuj model jako plik geometrii Bedrock Edition",
	"action.save_project": "Zapisz projekt",
	"action.save_project.desc": "Zapisuje bieżący model jako plik projektu",
	"action.save_project_as": "Zapisz projekt jako",
	"action.save_project_as.desc": "Zapisuje bieżący model jako plik projektu w nowej lokalizacji",
	"action.export_over": "Zapisz model",
	"action.export_over.desc": "Zapisuje model, tekstury i animacje poprzez nadpisanie plików",
	"action.add_locator": "Dodaj lokalizator",
	"action.add_locator.desc": "Dodaje nowy lokalizator do kontrolowania pozycji cząsteczek, smyczy itp",
	"action.uv_turn_mapping": "Włącz mapowanie",
	"action.uv_turn_mapping.desc": "Obróć mapowanie UV o 90 stopni",
	"action.remove_blank_faces": "Usuń puste powierzchnie",
	"action.remove_blank_faces.desc": "Usuwa wszystkie nieoteksturowane powierzchnie z zaznaczenia",
	"web.download_app": "Pobierz aplikację",
	"uv_editor.turned": "Turned Mapping",
	"display.reference.crossbow": "Kusza",
	"dialog.settings.search_results": "Wyniki wyszukiwania",
	"settings.animation_snap": "Animation Snap",
	"settings.animation_snap.desc": "Default snap interval for keyframes in the animation timeline in steps per second. This can also be changed per animation. The default value is 24.",
	"action.import_optifine_part": "Import OptiFine Part",
	"action.import_optifine_part.desc": "Importuj część modelu bytu dla OptiFine",
	"data.locator": "Lokalizator",
	"mode.start.no_recents": "Brak ostatnio otwartych modeli",
	"panel.element": "Element",
	"panel.element.position": "Pozycja",
	"panel.element.size": "Rozmiar",
	"panel.element.origin": "Punkt osi",
	"panel.element.rotation": "Obrót",
	"message.canvas_limit_error.title": "Błąd limitu przestrzeni roboczej",
	"message.canvas_limit_error.message": "Akcja nie mogła zostać wykonana poprawnie, ponieważ format ogranicza obszar roboczy do 48 jednostek. Przesuń punkt osi, aby temu zapobiec.",
	"data.effect": "Efekt",
	"generic.name": "Nazwa",
	"settings.recent_projects": "Limit ostatnich modeli",
	"settings.recent_projects.desc": "Maksymalna liczba ostatnich modeli do zapamiętania",
	"settings.volume": "Głośność",
	"settings.volume.desc": "Regulacja głośności dla efektów dźwiękowych w animacjach",
	"action.clear_timeline": "Wyczyść oś czasu",
	"action.clear_timeline.desc": "Wyczyść wszystkie niezaznaczone kości z osi czasu",
	"action.select_effect_animator": "Animuj Efekty",
	"action.select_effect_animator.desc": "Otwiera linię czas",
	"action.timeline_focus": "Filtruj kanały",
	"action.timeline_focus.desc": "Wybierz kanały animacji, które mają być wyświetlane na osi czasu",
	"timeline.particle": "Cząsteczka",
	"timeline.sound": "Dźwięk",
	"timeline.effects": "Efekty",
	"data.format": "Format",
	"format.optifine_part": "OptiFine Part",
	"format.optifine_part.desc": "JPM part for OptiFine entity models",
	"action.reverse_keyframes": "Odwróć klatki kluczowe",
	"action.reverse_keyframes.desc": "Odwróć kolejność wybranych klatek kluczowych",
	"generic.help": "Pomoc",
	"message.removed_faces": "Usunięto %0 powierzchni",
	"dialog.sketchfab_uploader.draft": "Szkic",
	"action.slider_pos": "Przesuń %0",
	"action.slider_pos.desc": "Przesuń kostki na osi %0",
	"action.slider_size": "Rozmiar %0",
	"action.slider_size.desc": "Zmień rozmiar kostek na osi %0",
	"action.slider_rotation": "Obróć %0",
	"action.slider_rotation.desc": "Obróć kostkę na osi %0",
	"action.slider_origin": "Punkt osi %0",
	"action.slider_origin.desc": "Przesuń punk osi na osi %0",
	"action.rotate_cw": "Obróć %0 +90",
	"action.rotate_cw.desc": "Obróć wybrane kostki o 90° na osi %0",
	"action.rotate_ccw": "Obróć %0 -90",
	"action.rotate_ccw.desc": "Obróć wybrane kostki o 90° na osi %0",
	"action.flip": "Przerzuć %0",
	"action.flip.desc": "Przerzuć wybrane kostki na oś %0",
	"action.center": "Wyśrodkuj %0",
	"action.center.desc": "Wyśrodkuj wybrane kostki na osi %0",
	"action.bring_up_all_animations": "Bring Up All Animators",
	"panel.bone": "Kość",
	"data.color": "Kolor",
	"generic.export": "Eksportuj",
	"generic.none": "Żadne",
	"status_bar.recording": "Nagrywanie timelapse",
	"message.add_to_palette": "Dodano do palety",
	"message.size_modifiers": "Przytrzymaj wciśnięty klawisz Ctrl lub Shift, aby przekształcać w mniejszych krokach.",
	"message.timelapse_start": "Timelapse rozpoczęty",
	"message.timelapse_stop": "Timelapse zatrzymany",
	"message.import_palette.replace_palette": "Zamień starą paletę",
	"message.import_palette.threshold": "Próg scalania",
	"dialog.timelapse.interval": "Interwał (sekundy)",
	"dialog.timelapse.source": "Źródło",
	"dialog.timelapse.source.interface": "Interfejs",
	"dialog.timelapse.source.locked": "Zablokowany kąt",
	"dialog.timelapse.destination": "Folder docelowy",
	"layout.color.checkerboard": "Szachownica",
	"layout.color.checkerboard.desc": "Tło sceny i edytora UV",
	"layout.font.code": "Code Font",
	"layout.css": "Własny CSS",
	"settings.category.paint": "Maluj",
	"settings.deactivate_size_limit": "Dezaktywuj limit rozmiaru",
	"settings.deactivate_size_limit.desc": "Wyłączenie ograniczenia rozmiaru dla określonych formatów modeli. OSTRZEŻENIE: Może to spowodować nieprawidłowe modele.",
	"settings.brush_opacity_modifier": "Modyfikator krycia pędzla",
	"settings.brush_opacity_modifier.desc": "Modyfikuj krycie pędzla podczas używania rysika",
	"settings.brush_size_modifier": "Modyfikator wielkości pędzla",
	"settings.brush_size_modifier.desc": "Modyfikuj rozmiar pędzla podczas używania rysika",
	"settings.brush_modifier.pressure": "Nacisk",
	"settings.brush_modifier.tilt": "Pochylenie",
	"category.color": "Kolor",
	"action.import_theme": "Importuj motyw",
	"action.export_theme": "Eksportuj motyw",
	"action.export_theme.desc": "Stwórz plik stylu bazowany na aktualnych ustawieniach",
	"action.slider_color_h": "Barwa",
	"action.slider_color_s": "Nasycenie",
	"action.slider_color_v": "Wartość",
	"action.add_to_palette": "Dodaj do palety",
	"action.add_to_palette.desc": "Dodaj zaznaczony kolor do palety kolorów",
	"action.import_palette": "Importuj paletę",
	"action.import_palette.desc": "Importuj plik palety",
	"action.export_palette": "Eksportuj paletę",
	"action.export_palette.desc": "Eksportuj paletę jako plik .GPL",
	"action.generate_palette": "Generuj paletę",
	"action.generate_palette.desc": "Wygeneruj paletę z tekstury",
	"action.sort_palette": "Sortuj paletę",
	"action.sort_palette.desc": "Sortuj wszystkie kolory na palecie według koloru i jasności",
	"action.timelapse": "Timelapse",
	"action.timelapse.desc": "Nagraj timelaps procesu modelowania",
	"action.add_keyframe": "Dodaj klatkę kluczową",
	"action.add_keyframe.desc": "Automatycznie dodawaj klatki kluczowe. Naciśnij Shift, aby wymusić podstawowe wartości",
	"action.bring_up_all_animations.desc": "Brings all modified animators into the timeline",
	"timeline.timeline": "Instrukcje",
	"menu.palette.load.default": "Podstawowa",
	"generic.import": "Importuj",
	"settings.brush_modifier.none": "Żaden",
	"action.export_entity": "Eksportuj byt Bedrock",
	"action.export_entity.desc": "Dodaj bieżący model jako byt do pliku mobs.json",
	"settings.highlight_cubes": "Podświetl kostki",
	"settings.highlight_cubes.desc": "Podświetlaj kostki po najechaniu na nie lub wybraniu ich",
	"action.add_marker": "Ustaw znacznik",
	"action.add_marker.desc": "Ustaw znacznik osi czasu",
	"timeline.pre_effect_script": "Skrypt",
	"format.skin": "Skórka",
	"format.skin.desc": "Edytuj skórki graczy i stworzeń",
	"message.sketchfab.setup_guide": "Chcesz dowiedzieć się jak ustawiać modele w Sketchfab? Przeczytaj %0",
	"dialog.skin.title": "Stwórz skórkę",
	"dialog.skin.model": "Skórka",
	"action.toggle_skin_layer": "Włącz warstwę skórki",
	"action.toggle_skin_layer.desc": "Włącz warstwę nakrycia głowy i ubrań",
	"action.gui_light": "Światło GUI",
	"action.gui_light.desc": "Wybierz sposób w jaki przedmiot jest podświetlony w ekwipunku",
	"action.gui_light.side": "Boczne światło",
	"action.gui_light.front": "Frontowe światło",
	"action.move_keyframe_back": "Przemieść klatki kluczowe do tyłu",
	"action.move_keyframe_forth": "Przemieść klatki kluczowe do przodu",
	"menu.help": "Pomoc",
	"menu.help.discord": "Serwer Discord",
	"menu.help.report_issue": "Zgłoś błąd",
	"menu.help.plugin_documentation": "Dokumentacja API pluginów",
	"menu.help.search_action": "Wyszukaj i wykonaj akcję",
	"menu.help.donate": "Wesprzyj",
	"menu.help.about": "O Blockbench...",
	"menu.preview.background.clipboard": "Wczytaj ze schowka",
	"dialog.ignore": "Ignoruj",
	"generic.unset": "Unset",
	"message.invalid_builtin_parent.title": "Nieprawidłowy wbudowany rodzic",
	"message.invalid_builtin_parent.message": "Link do nieprawidłowego modelu rodzica '%0' został usunięty w celu wyeksportowania prawidłowego modelu.",
	"dialog.resize_texture.fill": "Wypełnij za pomocą",
	"dialog.resize_texture.fill.transparent": "Przeźroczysty",
	"dialog.resize_texture.fill.color": "Kolor",
	"dialog.resize_texture.fill.repeat": "Powtórz",
	"dialog.scale.element_pivot": "Element Pivot",
	"dialog.scale.selection_center": "Środek zaznaczenia",
	"dialog.create_gif.length_mode": "Length Mode",
	"dialog.create_gif.length_mode.seconds": "Sekund",
	"dialog.create_gif.length_mode.frames": "Klatki",
	"dialog.create_gif.length_mode.animation": "Długość animacji",
	"dialog.create_gif.length_mode.turntable": "Turntable Rotation",
	"dialog.save_angle.projection": "Projekcja",
	"dialog.save_angle.projection.perspective": "Perspektywa",
	"dialog.save_angle.projection.orthographic": "Rzut ortograficzny",
	"dialog.sketchfab_uploader.animations": "Animacje",
	"dialog.settings.theme": "Motyw",
	"settings.category.interface": "Interfejs",
	"settings.preview_checkerboard": "Podgląd szachownicy",
	"settings.preview_checkerboard.desc": "Przełącz tło szachownicy za podglądem",
	"settings.uv_checkerboard": "Szachownica edytoru UV",
	"settings.uv_checkerboard.desc": "Przełącz tło szachownicy za edytorem UV",
	"category.paint": "Maluj",
	"action.fill_mode.color_connected": "Połączone kolory",
	"action.draw_shape_type": "Typ kształtu",
	"action.draw_shape_type.rectangle": "Prostokąt",
	"action.draw_shape_type.rectangle_h": "Rectangle (Hollow)",
	"action.draw_shape_type.ellipse": "Elipsa",
	"action.draw_shape_type.ellipse_h": "Ellipse (Hollow)",
	"action.draw_shape_type.line": "Linia",
	"action.mirror_painting": "Lustrzane malowanie",
	"action.mirror_painting.description": "Odbija lustrzanie pociągnięcia farbą na drugą stronę modelu",
	"action.lock_alpha": "Zablokuj kanał alfa",
	"action.lock_alpha.description": "Zablokuj przezroczystość wszystkich pikseli",
	"action.draw_shape_tool": "Rysuj Kształt",
	"action.draw_shape_tool.desc": "Narzędzie do rysowania prostych kształtów na teksturach",
	"action.export_gltf": "Eksportuj model glTF",
	"action.export_gltf.desc": "Eksportuj model i animacje jako plik glTF, aby użyć go w innych aplikacjach 3D",
	"action.transform_space": "Przestrzeń przekształceń",
	"action.transform_space.desc": "Domyślna przestrzeń przekształceń dla elementów i kości",
	"action.transform_space.global": "Globalnie",
	"action.transform_space.local": "Lokalnie",
	"action.toggle_camera_projection": "Przełącz projekcję kamery",
	"action.toggle_camera_projection.desc": "Przełączanie projekcji kamery między perspektywą a ortografią",
	"action.load_camera_angle": "Kąt kamery: %0",
	"action.load_camera_angle.desc": "Wczytaj kąt kamery '%0'",
	"action.slider_face_tint": "Tint Index",
	"action.slider_face_tint.desc": "Set the tint index of the current face. -1 means unset.",
	"menu.help.quickstart": "Quickstart Wizard",
	"menu.help.developer": "Deweloper",
	"menu.help.developer.dev_tools": "Otwórz Dev Toolsy",
	"menu.help.developer.reset_storage": "Reset do ustawień fabrycznych",
	"menu.help.developer.reset_storage.confirm": "Czy na pewno chcesz zresetować Blockbencha do ustawień fabrycznych? Spowoduje to usunięcie wszystkich własnych ustawień, przypisań klawiszy i zainstalowanych wtyczek.",
	"menu.help.developer.cache_reload": "Przeładowanie pamięci podręcznej",
	"menu.preview.orthographic": "Rzut ortograficzny",
	"menu.preview.save_angle": "Zapisz kąt...",
	"menu.preview.angle": "Kąty",
	"menu.preview.angle.initial": "Kąt początkowy",
	"menu.preview.maximize": "Maksymalizuj",
	"uv_editor.copy_selection": "Kopiuj zaznaczenie",
	"uv_editor.paste_selection": "Wklej zaznaczenie",
	"uv_editor.copy_paste_tool.place": "Place",
	"uv_editor.copy_paste_tool.mirror_x": "Odbij lustrzanie w osi X",
	"uv_editor.copy_paste_tool.mirror_y": "Odbij lustrzanie w osi Y",
	"uv_editor.copy_paste_tool.rotate": "Obróć o 90 stopni",
	"dialog.project.modded_entity_version": "Export Version",
	"dialog.save_angle.position": "Pozycja kamery",
	"dialog.save_angle.target": "Focal Point",
	"dialog.skin.pose": "Poza",
	"layout.color.frame": "Obramowanie okna",
	"layout.color.frame.desc": "Obramowanie i pasek tytułowy okna",
	"settings.large_grid_size": "Rozmiar siatki bloku",
	"settings.large_grid_size.desc": "Rozmiar siatki bloku",
	"action.load_plugin_from_url": "Załaduj plugin z URL",
	"action.load_plugin_from_url.desc": "Załaduj plugin z serwera podając adres URL",
	"action.cube_counter.desc": "Wyświetla bieżącą liczbę elementów i inne statystyki",
	"action.unlock_everything": "Odblokuj Wszystko",
	"action.unlock_everything.desc": "Odblokuj wszystkie grupy i elementy w outlinerze",
	"action.load_palette": "Załaduj palete",
	"action.load_palette.desc": "Wczytaj jeden z wbudowanych ustawieniach palety",
	"action.toggle_locked": "Toggle Lock",
	"action.toggle_locked.desc": "Toggle whether the selected elements are locked",
	"action.apply_display_preset": "Apply Preset",
	"action.apply_display_preset.desc": "Zastosuj domyślne lub niestandardowe ustawienia wyświetlania",
	"action.apply_display_preset.here": "Aplikuj na ten slot",
	"action.apply_display_preset.everywhere": "Aplikuj na wszystkie sloty",
	"action.resolve_keyframe_expressions": "Rozwiąż klatkę kluczową",
	"action.resolve_keyframe_expressions.desc": "Rozwiązuje wyrażenia matematyczne dla wybranych klatek kluczowyc",
	"action.fold_all_animations": "Fold All Animators",
	"menu.palette.load.empty": "Pusta",
	"switches.lock": "Zablokuj",
	"settings.render_sides": "Renderowanie stron",
	"settings.render_sides.desc": "Wybierz, która strona ściany jest renderowana",
	"settings.render_sides.auto": "Automatycznie",
	"settings.render_sides.front": "Na zewnątrz",
	"settings.render_sides.double": "Wewnątrz i na zewnątrz",
	"generic.enable": "Włącz",
	"generic.disable": "Wyłącz",
	"generic.redacted": "Redacted",
	"dialog.select_texture.import_all": "Importuj wszystkie",
	"dialog.skin.layer_template": "Layer Texture",
	"about.version.up_to_date": "Aktualna",
	"about.version.update_available": "Dostępna jest wersja %0",
	"settings.category.application": "Aplikacja",
	"settings.streamer_mode": "Tryb streamera",
	"settings.streamer_mode.desc": "Ukrywa wrażliwe dane, takie jak ostatnie modele",
	"settings.automatic_updates": "Automatyczne aktualizacje",
	"settings.automatic_updates.desc": "Automatycznie pobieraj nowe wersje i utrzymuj Blockbench w stanie aktualnym",
	"action.rotation_space": "Rotation Space",
	"action.focus_on_selection": "Wycentruj widok na zaznaczonych elementach",
	"action.focus_on_selection.desc": "Wyrównaj kamerę tak, aby znalazła się w środku bieżącego zaznaczenia.",
	"action.jump_to_timeline_start": "Przeskocz na początek animacji",
	"action.jump_to_timeline_end": "Przeskocz na koniec animacji",
	"menu.help.updating": "Aktualizowanie (%0%)",
	"menu.help.update_failed": "Aktualizacja nieudana",
	"menu.animation.loop.once": "Odtwórz Raz",
	"menu.animation.loop.hold": "Hold On Last Frame",
	"menu.animation.loop.loop": "Powtarzaj",
	"interface.streamer_mode_on": "Tryb streamera aktywny",
	"generic.reset": "Reset",
	"generic.restore": "Przywróć",
	"keys.mousewheel": "Kółko myszy",
	"message.delete_animation.title": "Usuń Animację",
	"message.delete_animation.message": "Animacja została usunięta z Blockbencha. Czy chcesz również usunąć animację z pliku, w którym została zapisana?",
	"message.no_animation_to_import": "Brak animacji do zaimportowania",
	"dialog.material_instances.title": "Material Instances",
	"dialog.animation_import.title": "Wybierz animacje do zaimportowania",
	"dialog.create_texture.padding": "Wypełnienie",
	"settings.fov": "Pole widzenia",
	"settings.fov.desc": "Pole widzenia kamery. Domyślnie to 45",
	"settings.minify_bbmodel": "Minified Project Files",
	"settings.minify_bbmodel.desc": "Write .bbmodel files minified into one line",
	"action.edit_material_instances": "Edytuj instancje materiału",
	"action.edit_material_instances.desc": "Edycja nazw instancji materiału dla geometrii bloków Minecraft Bedrock",
	"action.save_all_animations": "Zapisz wszystkie animacje",
	"action.save_all_animations.desc": "Zapisz wszystkie aktualnie załadowane animacje",
	"action.keyframe_interpolation": "Interpolacja",
	"action.keyframe_interpolation.desc": "Wybierz tryb interpolacji klatek kluczowych",
	"action.keyframe_interpolation.linear": "Liniowa",
	"action.keyframe_interpolation.catmullrom": "Gładka",
	"action.timeline_focus.hide_empty": "Ukryj puste kanały",
	"menu.file.preferences": "Preferencje",
	"menu.animation.blend_weight": "Blend Weight",
	"menu.animation.save": "Zapisz",
	"menu.animation.properties": "Właściwości",
	"menu.animation.file": "Plik",
	"menu.animation.snapping": "Snapping",
	"menu.animation.open_location": "Otwórz Lokalizację Pliku",
	"panel.keyframe.add_data_point": "Dodaj punkt danych klatki kluczowej",
	"panel.keyframe.remove_data_point": "Remove Data Point",
	"panel.keyframe.pre": "Przed",
	"panel.keyframe.post": "Po",
	"generic.all": "Wszystkie",
	"message.small_face_dimensions.title": "Incompatible Face Dimensions",
	"message.small_face_dimensions.message": "Zaznaczenie zawiera ściany, które są mniejsze niż 1 jednostka w jednym kierunku. System mapowania pudełkowego UV traktuje wszystkie ściany poniżej tego progu jako ściany o szerokości 0 pikseli. Tekstura na tych powierzchniach może więc nie działać poprawnie.",
	"message.small_face_dimensions.face_uv": "The current format supports per-face UV maps which can handle small face dimensions. Right click the affected cubes and change \"UV Mode\" to \"Per-face UV\".",
	"dialog.plugins.outdated_client": "Wymaga nowszej wersji programu Blockbench",
	"dialog.plugins.outdated_plugin": "Plugin jest przestarzały i nie działa z tą wersją Blockbench",
	"settings.motion_trails": "Ścieżki ruchu",
	"settings.motion_trails.desc": "Pokaż ścieżki ruchu w edytorze animacji",
	"settings.antialiasing": "Wygładzanie krawędzi",
	"settings.antialiasing.desc": "Przełącz wygładzanie krawędzi w podglądzie. Uruchom ponownie Blockbench aby zastosować zmiany",
	"action.timeline_frame_back": "Przeskocz o 1 klatkę do tyłu",
	"action.timeline_frame_forth": "Przeskocz o 1 klatkę do przodu",
	"panel.bone.ik": "Odwrócona kinematyka (eksperymentalne)",
	"settings.particle_tick_rate": "Particle Tick Rate",
	"settings.particle_tick_rate.desc": "Częstotliwość tykania dla efektów cząsteczkowych w tyknięciach na sekundę. Wartość domyślna to 30",
	"action.lock_motion_trail": "Zablokuj ścieżkę ruchu",
	"action.lock_motion_trail.desc": "Zablokuj ścieżkę ruchu dla aktualnie zaznaczonych grup",
	"menu.animation_file.unload": "Unload File",
	"data.null_object": "Pusty obiekt",
	"status_bar.toggle_sidebar": "Przełącz pasek boczny",
	"message.load_plugin_failed.title": "Nie udało się załadować pluginu",
	"message.load_plugin_failed.message": "Ensure that the base file name of the plugin matches the plugin ID `%0`, as specified in Plugin.register().",
	"dialog.project.uv_mode": "Tryb UV",
	"dialog.project.uv_mode.box_uv": "Box UV",
	"dialog.project.uv_mode.face_uv": "Per-face UV",
	"dialog.project.texture_size": "Rozmiar tekstury",
	"dialog.animation_export.title": "Wybierz animacje do wyeksportowania",
	"dialog.create_texture.rearrange_uv": "Zmień układ UV",
	"layout.color.subtle_text": "Subtle Text",
	"layout.color.subtle_text.desc": "Drugi kolor tekstu z mniejszym kontrastem",
	"settings.interface_scale": "Skala interfejsu",
	"settings.interface_scale.desc": "Skala interfejsu całego Blockbencha",
	"settings.background_rendering": "Renderowanie w tle",
	"settings.background_rendering.desc": "Aktualizuj podgląd, gdy okno nie jest na wierzchu",
	"settings.ctrl_shift_size": "Control + Shift Resolution",
	"settings.ctrl_shift_size.desc": "Resolution of the grid while holding control and shift",
	"settings.hardware_acceleration": "Akceleracja sprzętowa",
	"settings.hardware_acceleration.desc": "Zlecanie zadań renderowania karcie graficznej. Wymagany restart do zastosowania zmiany",
	"action.explode_skin_model": "Explode Skin Model",
	"action.explode_skin_model.desc": "Toggles an explosion view that allows you to edit covered faces",
	"action.export_minecraft_skin": "Eksportuj skórkę Minecraft",
	"action.export_minecraft_skin.desc": "Wyeksportuj skórkę jako teksturę PNG",
	"action.add_null_object": "Dodaj pusty obiekt",
	"action.add_null_object.desc": "Dodaje nowy pusty obiekt",
	"action.animated_texture_frame": "Animated Texture Frame",
	"action.animated_texture_frame.desc": "Ustawia bieżącą klatkę animowanej tekstury",
	"action.export_animation_file": "Eksportuj animację...",
	"action.export_animation_file.desc": "Eksportuj wybrane animacje do nowego pliku",
	"action.timeline_graph_editor": "Przełącz edytor wykresów",
	"action.timeline_graph_editor.desc": "Toggle the timeline between graph editor view and keyframe view",
	"menu.file.recent.clear": "Wyczyść ostatnie pliki",
	"switches.shade": "Shade",
	"generic.share": "Udostępnij",
	"dates.minute": "%0 Minuta",
	"dates.minutes": "%0 Minuty",
	"dates.hour": "%0 Godzina",
	"dates.hours": "%0 Godzin",
	"dates.day": "%0 Dzień",
	"dates.days": "%0 Dni",
	"dates.week": "%0 Tygodnia",
	"dates.weeks": "%0 Tygodni",
	"dates.year": "%0 Roku",
	"dates.years": "%0 Lat",
	"message.installed_plugin": "Pomyślnie zainstalowano plugin %0",
	"message.installed_plugin_fail": "Nie udało się zainstalować plugina %0",
	"dialog.share_model.title": "Udostępnij Model",
	"dialog.share_model.expire_time": "Termin wygaśnięcia",
	"dialog.share_model.failed": "Nie udało się przesłać modelu",
	"action.import_java_block_model": "Dodaj model Bloku/Przedmiotu Java",
	"action.import_java_block_model.desc": "Dodaj model bloku/itemu Minecraft Java z pliku json do bieżącego modelu",
	"action.share_model": "Udostępnij...",
	"action.share_model.desc": "Wygeneruj krótki link, żeby udostępnić swój model",
	"action.import_project": "Importuj Projekt",
	"action.import_project.desc": "Importuj inny projekt z pliku .bbmodel do bieżącego projektu",
	"dialog.toolbar_edit.hidden_tools": "Niektóre narzędzia mogą być ukryte, ponieważ nie są dostępne w bieżącym trybie, formacie lub sytuacji.",
	"settings.camera_near_plane": "Kamera w pobliżu płaszczyzny",
	"settings.camera_near_plane.desc": "Minimalny dystans z kamery gdzie objekt się renderuje. Wyższe wartości obniża Z-fighting. Domyślne to 1.",
	"mode.start.keymap_preference.desc": "Jeśli jesteś nowym użytkownikiem Blockbencha i przechodzisz z innego programu 3D, możesz wybrać mapę klawiszy, aby ułatwić sobie przejście. Możesz zmienić mapę klawiszy lub poszczególne przypisania klawiszy później w ustawieniach.",
	"message.load_keymap": "Czy na pewno chcesz załadować tę mapę klawiszy? To nadpisze twoje obecne przypisania klawiszy.",
	"message.keymap_loaded": "Mapa klawiszy załadowana",
	"dialog.convert_project.current_format": "Aktualny format",
	"dialog.create_texture.rearrange_uv.desc": "Utwórz nowy układ UV, aby nadać każdej ścianie jej własne miejsce na teksturze",
	"dialog.create_texture.power.desc": "Zablokuj automatyczny rozmiar tekstury do potęgi 2, takiej jak 64 lub 128. Jest to wymagane przez niektóre programy",
	"dialog.create_texture.double_use.desc": "Jeśli dwa elementy mają już przypisaną tę samą przestrzeń UV, zachowaj ją w ten sposób w nowej mapie",
	"dialog.create_texture.padding.desc": "Dodaj niewielkie wypełnienie między poszczególnymi częściami szablonu",
	"dialog.create_texture.resolution.desc": "Podstawowa rozdzielczość tekstury, w pikselach na metr. Rzeczywisty rozmiar mapy tekstury może się różnić w zależności od ilości i wielkości elementów.",
	"dialog.create_gif.color": "Kolor tła",
	"dialog.save_angle.zoom": "Przybliżenie",
	"dialog.skin.variant": "Wariant",
	"dialog.flip_animation.info": "Przeciwległe kości są identyfikowane przez słowa kluczowe \"lewa\" i \"prawa\" w ich nazwie.",
	"dialog.export_private_settings.title": "Prywatne ustawienia",
	"dialog.export_private_settings.message": "Twój plik zawiera następujące prywatne informacje: **%0**. Usuń te wartości, jeśli planujesz udostępnić plik komuś innemu.",
	"dialog.export_private_settings.keep": "Zachowaj",
	"settings.timecode_frame_number": "Wyświetlanie kodów czasowych jako numerów klatek",
	"settings.timecode_frame_number.desc": "Wyświetlanie kodów czasowych frakcji na osi czasu w postaci numeru klatki zamiast centysekundy",
	"settings.animation_sample_rate": "Animation Sample Rate",
	"settings.animation_sample_rate.desc": "Sample rate in samples per second for curves that the respective format does not support natively",
	"keybind.preview_zoom": "Przybliżenie widoku",
	"action.gradient_tool": "Narzędzie gradientu",
	"action.gradient_tool.desc": "Utwórz kolorowy gradient na swojej teksturze",
	"action.import_settings": "Importuj ustawienia",
	"action.import_settings.desc": "Importuj plik .bbsettings",
	"action.export_settings": "Eksportuj ustawienia",
	"action.export_settings.desc": "Wyeksportuj ustawienia Blockbencha jako plik .bbsettings",
	"action.load_keymap": "Załaduj mapę klawiszy",
	"action.load_keymap.default": "Domyślne (gładzik/mysz)",
	"action.load_keymap.mouse": "Domyślne (mysz)",
	"action.load_keymap.default.desc": "Default Blockbench keybindings, with viewport navigation controls optimized for use on laptop trackpads",
	"action.load_keymap.mouse.desc": "Default Blockbench keybindings, with viewport navigation bound to the middle mouse button",
	"action.load_keymap.blender.desc": "Mapa klawiszy dla użytkowników, którzy są zaznajomieni z kontrolkami Blendera",
	"action.load_keymap.cinema4d.desc": "Mapa klawiszy dla użytkowników, którzy są zaznajomieni z kontrolkami w Cinema 4D",
	"action.load_keymap.maya.desc": "Mapa klawiszy dla użytkowników, którzy są zaznajomieni z kontrolkami programu Autodesk Maya",
	"action.import_keymap": "Importuj mapę klawiszy",
	"action.import_keymap.desc": "Importuj przypisanie klawiszy z pliku .bbkeymap",
	"action.export_keymap": "Eksportuj mapę klawiszy",
	"action.export_keymap.desc": "Eksportuj aktualne przypisania klawiszy jako plik .bbkeymap",
	"action.edit_history": "Edytuj historię...",
	"action.edit_history.desc": "Przeglądaj historię edycji i cofaj lub ponawiaj kroki",
	"action.group_elements": "Grupuj elementy",
	"action.group_elements.desc": "Włóż wybrane elementy w nową grupę",
	"action.unfold_groups": "Rozwiń grupy",
	"action.unfold_groups.desc": "Rozwiń wszystkie grupy w outlinerze",
	"action.edit_bedrock_binding": "Edytuj przypisanie...",
	"action.edit_bedrock_binding.desc": "Zmień kość, z którą związana jest geometria",
	"action.pick_screen_color": "Pick Screen Color",
	"action.pick_screen_color.desc": "Wybierz kolor z jakiegoś miejsca na ekranie",
	"action.view_mode": "Tryb przeglądania",
	"action.view_mode.desc": "Zmiana trybu widoku modelu",
	"action.view_mode.textured": "Oteksturowany",
	"action.view_mode.solid": "Solid",
	"action.view_mode.wireframe": "Szkielet",
	"action.toggle_sidebars": "Przełącz paski boczne",
	"action.toggle_sidebars.desc": "Włącz lub wyłącz pasków bocznych",
	"action.set_animation_end": "Ustaw koniec animacji",
	"action.set_animation_end.desc": "Ustaw koniec wybranej animacji na aktualny czas na osi czasu",
	"action.flip_animation": "Flip Animation",
	"action.flip_animation.desc": "Przerzucenie części animacji poprzez skopiowanie wybranych klatek kluczowych na drugą stronę modelu",
	"action.graph_editor_zero_line": "Include Zero Line",
	"action.graph_editor_zero_line.desc": "Whether the graph editor always includes the zero line in the view",
	"menu.texture.render_mode": "Tryb renderowania",
	"menu.texture.render_mode.emissive": "Emissive",
	"menu.texture.render_mode.layered": "Layered",
	"menu.preview.angle.edit": "Zmień kąt...",
	"menu.animation.start_delay": "Start Delay",
	"menu.animation.loop_delay": "Opóźnienie pętli",
	"menu.animation.flip_keyframes": "Flip Keyframes",
	"menu.mobile_keyboard.disable_all": "Wyłącz wszystkie",
	"panel.keyframe.toggle_uniform_scale": "Toggle Uniform Scale",
	"camera_angle.common_isometric_right": "Izometryczny prawy (2:1)",
	"camera_angle.common_isometric_left": "Izometryczny lewy (2:1)",
	"camera_angle.true_isometric_right": "Prawdziwy izometryczny prawy (30°)",
	"camera_angle.true_isometric_left": "Prawdziwy izometryczny lewy (30°)",
	"menu.help.wiki": "Wiki Blockbencha",
	"settings.update_to_prereleases": "Aktualizacja do wersji przedpremierowej",
	"settings.update_to_prereleases.desc": "Automatycznie aktualizuj Blockbench do wersji beta, aby testować nowe funkcje. Wersje przedpremierowe mogą być niestabilne, nie włączaj tej opcji jeśli polegasz na Blockbench w pracy lub innych ważnych projektach.",
	"data.separator.spacer": "Spacer",
	"data.separator.linebreak": "Line Break",
	"data.setting": "Ustawienie",
	"generic.select_all": "Wybierz wszystko",
	"generic.select_none": "Wybierz nic",
	"projects.new_tab": "Nowa zakładka",
	"projects.close_tab": "Zamknij zakładkę",
	"message.invalid_format.title": "Nieprawidłowy format",
	"message.invalid_format.message": "Ten model został stworzony w formacie '%0', który nie jest dostępny w twojej instalacji Blockbencha. Najprawdopodobniej potrzebujesz pluginu, aby otworzyć go poprawnie.",
	"message.invalid_link": "Nieprawidłowy lub wygasły link modelu",
	"message.default_textures.current": "Aktualna ścieżka",
	"message.update_after_restart": "Aktualizacja zostanie zainstalowana po następnym uruchomieniu",
	"message.copy_paste_tool_viewport": "To narzędzie może być używane tylko w panelu UV",
	"dialog.project.shadow_size": "Rozmiar cienia",
	"dialog.find_replace.target": "Cel",
	"dialog.find_replace.target.element_names": "Nazwy elementów",
	"dialog.find_replace.target.group_names": "Nazwy grup",
	"dialog.find_replace.target.animation_names": "Nazwy animacji",
	"dialog.find_replace.target.keyframe_values": "Wartości klatek kluczowych",
	"dialog.find_replace.find": "Znajdź",
	"dialog.find_replace.replace": "Zamień",
	"dialog.find_replace.regex": "Regular Expression",
	"dialog.add_primitive.shape": "Kształt",
	"dialog.add_primitive.shape.circle": "Kółko",
	"dialog.add_primitive.shape.tube": "Tuba",
	"dialog.add_primitive.shape.cone": "Stożek",
	"dialog.add_primitive.shape.cylinder": "Cylinder",
	"dialog.add_primitive.shape.sphere": "Sfera",
	"dialog.add_primitive.shape.torus": "Torus",
	"dialog.add_primitive.shape.cube": "Kostka",
	"dialog.add_primitive.shape.pyramid": "Piramida",
	"dialog.add_primitive.diameter": "Średnica",
	"dialog.add_primitive.height": "Wysokość",
	"dialog.add_primitive.sides": "Ściany",
	"dialog.add_primitive.minor_diameter": "Grubość",
	"dialog.add_primitive.minor_sides": "Minor Sides",
	"dialog.create_texture.combine_polys": "Połącz ściany",
	"dialog.create_texture.combine_polys.desc": "Combine faces into connected UV islands",
	"dialog.model_stats.meshes": "Siatki",
	"dialog.export_private_settings.omit": "Leave Out",
	"layout.select": "Wybierz",
	"layout.options": "Opcje",
	"layout.color": "Schemat kolorów",
	"layout.documentation": "Dokumentacja",
	"layout.color.bright_ui_text": "Jasne UI",
	"layout.color.bright_ui_text.desc": "Text on bright backgrounds",
	"layout.name": "Nazwa",
	"layout.author": "Autor",
	"settings.dialog.desc": "Show the \"%0\" dialog",
	"settings.export_empty_groups": "Eksportuj puste grupy",
	"settings.export_empty_groups.desc": "Uwzględniaj grupy bez zawartości w eksportowanych plikach",
	"category.separators": "Separatory",
	"keybind.preview_area_select": "Area Select",
	"action.color_erase_mode": "Tryb kasowania",
	"action.color_erase_mode.desc": "Po włączeniu trybu wymazywania narzędzia takie jak wypełnienie i prostokąt usuwają kolory, zamiast je dodawać.",
	"action.open_from_link": "Otwórz model poprzez link...",
	"action.open_from_link.desc": "Otwórz model z adresu URL blckbn.ch",
	"action.import_obj": "Importuj model OBJ",
	"action.import_obj.desc": "Importuj obiekty z modelu OBJ jako siatkę",
	"action.add_plugin": "Zainstaluj plugin",
	"action.add_plugin.desc": "Install a plugin through Action Control",
	"action.remove_plugin": "Odinstaluj plugin",
	"action.remove_plugin.desc": "Odinstaluj plugin za pomocą narzędzia Action Control",
	"action.add_mesh": "Dodaj siatkę",
	"action.add_mesh.desc": "Dodaje nową siatkę",
	"action.add_texture_mesh": "Dodaj teksturę siatki",
	"action.add_texture_mesh.desc": "Dodaje nową teksturę siatki",
	"action.find_replace": "Znajdź/Zamień...",
	"action.find_replace.desc": "Znajdź i zastąp części nazw",
	"action.hide_everything_except_selection": "Ukryj wszystko poza zaznaczonymi elementami",
	"action.hide_everything_except_selection.desc": "Przełączanie widoczności wszystkich elementów oprócz tych, które są zaznaczone",
	"action.transform_space.normal": "Zwykle",
	"action.selection_mode": "Tryb zaznaczania",
	"action.selection_mode.desc": "Change how elements can be selected in the viewport",
	"action.selection_mode.object": "Obiekt",
	"action.selection_mode.face": "Ściana",
	"action.selection_mode.vertex": "Wierzchołek",
	"action.create_face": "Stwórz ścianę lub linię",
	"action.create_face.desc": "Tworzy nową ścianę lub linię pomiędzy wybranymi wierzchołkami",
	"action.convert_to_mesh": "Przekonwertuj na siatkę",
	"action.convert_to_mesh.desc": "Przekonwertuj zaznaczone elementy na siatkę",
	"action.invert_face": "Odwróć ścianę",
	"action.invert_face.desc": "Odwróć wybrane ściany, aby były zwrócone w przeciwnym kierunku",
	"action.extrude_mesh_selection": "Extrude Selection",
	"action.extrude_mesh_selection.desc": "Extrude the selected parts of the mesh",
	"action.loop_cut": "Loop Cut",
	"action.loop_cut.desc": "Podziel siatkę w pętli przez wybraną linię",
	"action.merge_meshes": "Scal siatki",
	"action.merge_meshes.desc": "Scal wiele siatek w jedną",
	"action.keyframe_uniform": "Uniform Scaling",
	"action.keyframe_uniform.desc": "Enable uniform scaling on the selected keyframes",
	"menu.locator.ignore_inherited_scale": "Ignoruj skalę dziedziczoną",
	"menu.texture.elements": "Zastosuj do elementów",
	"uv_editor.transparent_face": "Przezroczysta ściana",
	"display.pose_angle": "Kąt pozy (tylko do podglądu)",
	"data.mesh": "Siatka",
	"dialog.create_texture.type": "Typ",
	"dialog.create_texture.type.blank": "Pusty",
	"dialog.create_texture.type.template": "Szablon tekstury",
	"dialog.create_texture.type.color_map": "Szablon kolorów jednolitych",
	"dialog.sketchfab_uploader.suggested_tags": "Sugerowane tagi",
	"dialog.sketchfab_uploader.category": "Kategoria",
	"dialog.sketchfab_uploader.category2": "Kategoria 2",
	"layout.restore_backup": "Twój niestandardowy motyw \"%0\" został nadpisany. Kliknij tutaj, aby go przywrócić.",
	"layout.borders": "Obramowania",
	"action.fill_mode.element": "Element",
	"action.inset_mesh_selection": "Inset Selection",
	"action.inset_mesh_selection.desc": "Inset the selected parts of the mesh",
	"action.dissolve_edges": "Dissolve Edges",
	"action.dissolve_edges.desc": "Dissolve selected edges in a mesh and merge the faces they divide",
	"action.split_mesh": "Podziel siatkę",
	"action.split_mesh.desc": "Podziel wybrane ściany siatki w nową siatkę",
	"action.merge_vertices": "Scal wierzchołki",
	"action.merge_vertices.desc": "Scal wybrane wierzchołki w pozycji pierwszego wybranego wierzchołka",
	"action.view_mode.normal": "Face Orientation",
	"action.snap_uv_to_pixels": "Snap UV to Pixels",
	"action.snap_uv_to_pixels.desc": "Snaps the selected UV vertices to the pixel grid",
	"menu.file.import.import_open_project": "Importuj otwarty projekt",
	"menu.help.unlock_projects": "Odblokuj wszystkie projekty",
	"status_bar.selection.faces": "%0 Ściań",
	"status_bar.selection.vertices": "%0 Wierzchołków",
	"message.merged_vertices": "Znaleziono i połączono %0 wierzchołków w %1 lokalizacjach",
	"settings.vertex_merge_distance": "Odległość scalania wierzchołków",
	"settings.vertex_merge_distance.desc": "Odległość, w ramach której wierzchołki są scalane przy użyciu scalania przez odległość",
	"settings.show_only_selected_uv": "Pokaż tylko wybrane UV",
	"settings.show_only_selected_uv.desc": "Domyślnie wyświetlaj tylko wybrane twarze UV w edytorze UV",
	"action.merge_vertices.merge_all": "Scal wszystko",
	"action.merge_vertices.merge_all_in_center": "Scal wszystko w centrum",
	"action.merge_vertices.merge_by_distance": "Scal według odległości",
	"action.merge_vertices.merge_by_distance_in_center": "Scalanie według odległości w centrum",
	"action.uv_rotate_left": "Obróć UV w lewo",
	"action.uv_rotate_left.desc": "Obróć wybrane ściany UV w kierunku przeciwnym do ruchu wskazówek zegara.",
	"action.uv_rotate_right": "Obróć UV w prawo",
	"action.uv_rotate_right.desc": "Obróć wybrane twarze UV zgodnie z ruchem wskazówek zegara",
	"menu.uv.display_uv": "Wyświetl UV",
	"menu.uv.display_uv.selected_faces": "Zaznaczone ściany",
	"menu.uv.display_uv.selected_elements": "Wszystkie ściany",
	"menu.uv.display_uv.all_elements": "Wszystkie ściany na wszystkich elementach",
	"menu.paste.face": "Ściana UV",
	"menu.paste.mesh_selection": "Wybór siatki",
	"menu.paste.outliner": "Elementy",
	"uv_editor.show_all_faces": "Pokaż wszystkie ściany",
	"uv_editor.show_selected_faces": "Pokaż wybrane ściany",
	"status_bar.selection.edges": "%0 Krawędzi",
	"action.selection_mode.edge": "Krawędź",
	"message.cannot_re_import.title": "Model nie może zostać ponownie zaimportowany",
	"message.cannot_re_import.message": "Wybrany format modelu nie może być zaimportowany do Blockbencha ponownie. Upewnij się, że zapisujesz model w pliku projektu.",
	"generic.default": "Domyślny",
	"units.pixels_per_meter": "%0 Pikseli na metr",
	"mode.pose": "Poza",
	"modifier_actions.resize_both_sides": "Zmień rozmiar w dwóch kierunkach",
	"modifier_actions.resize_one_side": "Zmień rozmiar w jednym kierunku",
	"modifier_actions.draw_line": "Narysuj linię",
	"modifier_actions.drag_without_snapping": "Drag without snapping",
	"modifier_actions.stretch_keyframes": "Stretch keyframes",
	"modifier_actions.resize_background": "Zmień rozmiar tła",
	"modifier_actions.select_multiple": "Zaznacz wiele",
	"modifier_actions.select_range": "Wybierz zakres",
	"modifier_actions.drag_to_duplicate": "Przeciągnij aby powielić",
	"modifier_actions.uniform_scaling": "Uniform Scaling",
	"modifier_actions.snap_direction": "Snap Direction",
	"message.no_valid_elements": "No valid elements selected...",
	"dialog.add_primitive.shape.plane": "Płaszczyzna",
	"dialog.save_angle.rotation_mode": "Rotation Mode",
	"dialog.save_angle.rotation": "Obrót",
	"dialog.save_angle.fov": "Pole widzenia",
	"settings.hide_tab_bar": "Automatycznie ukrywaj pasek tab",
	"settings.hide_tab_bar.desc": "Ukryj pasek tab, gdy otwarta jest tylko jedna karta",
	"settings.status_bar_modifier_keys": "Suggest Modifier Keys in Status Bar",
	"settings.status_bar_modifier_keys.desc": "Display context aware suggested modifier keys in the status bar",
	"settings.ground_plane": "Ground Plane",
	"settings.ground_plane.desc": "Show a floor plane below the model",
	"settings.preview_paste_behavior": "Default Viewport Paste Behavior",
	"settings.preview_paste_behavior.desc": "Select the behavior when pasting something into the viewport in Edit mode and multiple options are available",
	"settings.preview_paste_behavior.always_ask": "Zawsze pytaj",
	"action.new_window": "Nowe okno",
	"action.new_window.desc": "Otwiera nowe okno Blockbencha",
	"action.export_collada": "Eksportuj model Collada (dae)",
	"action.export_collada.desc": "Eksportuj model i animacje jako plik dae, aby używać ich w innych programach 3D",
	"action.paint_mode_uv_overlay": "UV Overlay",
	"action.paint_mode_uv_overlay.desc": "Display the UV map as an overlay in paint mode",
	"action.bake_animation_into_model": "Bake Animation Pose into Model",
	"action.bake_animation_into_model.desc": "Bake the currently displayed animation frame into the model. Only applies rotation and position, scale is ignored.",
	"action.keyframe_interpolation.step": "Step",
	"action.set_ik_target": "Set IK Target",
	"action.set_ik_target.desc": "Select the target bone that should be moved by this null object via Inverse Kinematics",
	"menu.action_control.type.tab": "Tab",
	"menu.action_control.type.angle": "Kąt kamery",
	"menu.action_control.recent_in_streamer_mode": "Na pewno? Tryb Streamera jest włączony",
	"menu.action_control.recent_in_streamer_mode.desc": "Are you sure you want to display recent models?",
	"menu.tools": "Tools",
	"menu.file.recent.more": "View More...",
	"menu.null_object.lock_ik_target_rotation": "Lock IK Target Rotation",
	"menu.animation_file.import_remaining": "Import Remaining from File",
	"edit.loop_cut.offset": "Offset",
	"edit.extrude_mesh_selection.extend": "Extend",
	"cube.color.pink": "Pink",
	"cube.color.silver": "Srebrny",
	"dialog.plugins.offline": "Brak połączenia internetowego",
	"dialog.create_texture.pixel_density": "Pixel Density",
	"dialog.create_texture.pixel_density.desc": "The pixel density of the texture, in pixels per meter. The size of the texture map may differ depending on the amount and size of elements.",
	"panel.skin_pose": "Poza",
	"panel.skin_pose.none": "Żadna",
	"panel.skin_pose.natural": "Naturalna",
	"panel.skin_pose.walking": "Chodzenie",
	"panel.skin_pose.crouching": "Kucanie",
	"panel.skin_pose.sitting": "Siedzenie",
	"panel.skin_pose.jumping": "Skakanie",
	"panel.skin_pose.aiming": "Celowanie",
	"edit.loop_cut.direction": "Kierunek",
	"data.texture_mesh": "Texture Mesh",
	"generic.left": "Left",
	"generic.right": "Right",
	"mode.start.quick_setup": "Quick Setup",
	"mode.start.keymap": "Keymap",
	"mode.start.quick_setup.more_themes": "More...",
	"dialog.resize_texture.animation_frames": "Animation Frames",
	"dialog.export_emission_map.title": "Export Emission Map",
	"dialog.export_emission_map.format": "Format",
	"dialog.export_emission_map.format.luminance": "Luminance",
	"dialog.export_emission_map.format.luminance_inverted": "Luminance Inverted",
	"dialog.export_emission_map.format.colors": "Colors",
	"dialog.export_emission_map.threshold": "Transparency Threshold",
	"dialog.export_emission_map.round_up": "Round Up to %0 x %1",
	"dialog.export_emission_map.flip_y": "Flip Y Axis",
	"dialog.select.type": "Element Type",
	"dialog.create_texture.max_edge_angle": "Edge Angle Threshold",
	"dialog.create_texture.max_edge_angle.desc": "The maximum angle between two faces at which they will still be combined",
	"dialog.create_texture.max_island_angle": "Island Angle Threshold",
	"dialog.create_texture.max_island_angle.desc": "The maximum angle that can be combined into the same UV island",
	"settings.mobile_panel_side": "Mobile Panel Side",
	"settings.mobile_panel_side.desc": "Select which side of the screen panels are displayed on when using Blockbench on in landscape orientation",
	"settings.obj_face_export_mode": "OBJ Face Export Mode",
	"settings.obj_face_export_mode.desc": "Choose to let the OBJ exporter convert all faces into tris or quads",
	"settings.obj_face_export_mode.both": "Default",
	"settings.obj_face_export_mode.tris": "Convert to Tris",
	"settings.obj_face_export_mode.quads": "Convert to Quads",
	"action.seam_tool": "Seam Tool",
	"action.seam_tool.desc": "Tool to define UV seams on mesh edges",
	"action.resolve_group": "Resolve Group",
	"action.resolve_group.desc": "Resolve the group while retaining its children in the same place",
	"action.move_to_group": "Move to",
	"action.move_to_group.desc": "Move the selected elements to a different outliner group or element",
	"action.select_seam": "Select UV Seam",
	"action.select_seam.desc": "Select the UV seam mode for the selected edges",
	"action.select_seam.auto": "Auto",
	"action.select_seam.join": "Join",
	"action.select_seam.divide": "Divide",
	"action.adjust_brightness_contrast": "Adjust Brightness & Contrast...",
	"action.adjust_brightness_contrast.desc": "Adjust the brightness and contrast of the selected texture",
	"action.adjust_saturation_hue": "Adjust Saturation & Hue...",
	"action.adjust_saturation_hue.desc": "Adjust the saturation and hue of the selected texture",
	"action.invert_colors": "Invert Colors",
	"action.invert_colors.desc": "Invert all colors of the selected texture",
	"action.adjust_curves": "Adjust Curves...",
	"action.adjust_curves.desc": "Adjust the brightness curves of the selected texture",
	"action.flip_texture_x": "Flip Horizontally",
	"action.flip_texture_y": "Flip Vertically",
	"action.resize_texture": "Resize Texture...",
	"action.view_mode.uv": "UV Preview",
	"action.append_to_template": "Append Elements to Template...",
	"action.append_to_template.desc": "Add the currently selected elements to the texture template",
	"action.move_texture_with_uv": "Move Texture with UV",
	"action.move_texture_with_uv.desc": "Move the texture of the face along when dragging UV faces",
	"action.timeline_setups": "Timeline Setups",
	"action.save_timeline_setup": "Save Timeline Setup...",
	"action.save_timeline_setup.desc": "Save a preset for the currently selected animators and channels",
	"menu.texture": "Texture",
	"menu.texture.render_mode.default": "Default",
	"menu.texture.merge_onto_texture": "Merge Onto Texture Above",
	"menu.animation.unload": "Unload",
	"panel.timeline": "Timeline",
	"action.pan_tool": "Pan Tool",
	"action.pan_tool.desc": "Tool to navigate in the viewport and the texture editor",
	"mode.start.recent.favorite": "Mark as Favorite",
	"mode.start.info": "Info",
	"mode.start.target": "Target",
	"mode.start.start": "Start",
	"mode.start.create_new": "Create New Model",
	"mode.start.format.informations": "Good to know:",
	"mode.start.format.resources": "Resources:",
	"format.free.info.meshes": "In this format, you can create low poly models using cubes and custom shaped meshes.",
	"format.free.info.limitation": "Models cannot be loaded into games that need specialized formats, such as Minecraft.",
	"format.skin.info.skin": "This format is designed to create Minecraft skins and entity textures.",
	"format.skin.info.model": "The model cannot be changed. In order to make changes to the model, first convert to a different format via **File** > **Convert Project**.",
	"format.java_block.info.rotation": "Rotations are limited to one axis per element",
	"format.java_block.info.size": "The model is limited to a size of 3 by 3 by 3 blocks. Display settings can make item models larger though",
	"format.java_block.info.animation": "This format does not support animations in vanilla Minecraft. If you are creating a mod, you can use GeckoLib to animate models. If not, the only way to animate is to switch out the model using commands or animated textures.",
	"format.bedrock.info.textures": "Each model can only have one texture",
	"format.bedrock_block": "Bedrock Block",
	"format.bedrock_block.desc": "Block model for Minecraft Bedrock Edition",
	"format.modded_entity.info.integer_size": "The size of individual cubes is limited to integers.",
	"format.modded_entity.info.format": "Models are written in Java code instead of dedicated data structures like all other Blockbench export formats.",
	"format.optifine_entity.info.optifine_required": "Users without OptiFine installed won't see the model.",
	"format.optifine_entity.info.pivots": "Bone pivots are locked, so it is a good idea to leave them untouched.",
	"format_category.low_poly": "Low-Poly",
	"format_category.minecraft": "Minecraft",
	"format_category.other": "Other",
	"format_category.loaders": "Loaders",
	"message.recover_backup.recover": "Recover",
	"message.invalid_characters.title": "Invalid Path",
	"message.invalid_characters.message": "The path of the imported file contains invalid characters, uppercase letters, or white spaces. The supported characters are: %0",
	"dialog.share_model.thumbnail": "Thumbnail",
	"dialog.skin.high_res_texture": "Please note that skins with the selected resolution will not work as regular Minecraft skins. Select a lower resolution.",
	"settings.allow_display_slot_mirror": "Allow Display Slot Mirroring",
	"settings.allow_display_slot_mirror.desc": "Allow Display slots for Java item models to be mirrored. WARNING: This only works in Minecraft 1.14 or earlier or in special cases.",
	"action.switch_tabs": "Switch Tabs",
	"action.switch_tabs.desc": "Cycle between opened tabs. Hold shift to cycle in the opposite direction.",
	"action.unselect_all": "Unselect All",
	"action.save_palette": "Save Palette...",
	"action.save_palette.desc": "Save the current color palette inside Blockbench for later use",
	"action.keyframe_column_create": "Create Keyframe Column",
	"action.keyframe_column_create.desc": "Key all channels in the timeline at the current timecode, if they already have keyframes",
	"action.keyframe_column_select": "Select Keyframe Column",
	"action.keyframe_column_select.desc": "Select all keyframes in the timeline along a column below the playhead",
	"menu.uv": "UV",
	"menu.keyframe": "Keyframe",
	"menu.palette.load.update": "Update Palette",
	"menu.palette.load.update.desc": "Updates this palette with the colors of the current Blockbench palette",
	"menu.timeline_marker.set_time": "Set Time...",
	"uv_editor.scale_uv": "Scale UV",
	"action.preview_scene": "Preview Scene",
	"action.preview_scene.desc": "Change the model preview scene",
	"preview_scene.minecraft_overworld": "Overworld",
	"preview_scene.minecraft_nether": "Nether",
	"preview_scene.minecraft_end": "End",
	"dialog.project.modded_entity_flip_y": "Flip Y Axis",
	"preview_scene.studio": "Studio",
	"format.image": "Image",
	"modifier_actions.set_copy_source": "Set Copy Source",
	"message.load_images.title": "Load Images",
	"message.load_images.edit_image": "Edit Image",
	"dialog.add_primitive.align_edges": "Align Edges",
	"dialog.flip_animation.show_in_timeline": "Show modified bones in timeline",
	"settings.default_cube_size": "Cube Size",
	"settings.default_cube_size.desc": "Set the default cube size when creating a new cube",
	"settings.uniform_keyframe": "Uniform Scale Keyframes",
	"settings.uniform_keyframe.desc": "Set scale keyframes to uniform scaling by default",
	"settings.nearest_rectangle_select": "Rectangle Selection: Nearest Edge",
	"settings.nearest_rectangle_select.desc": "Snap rectangle selections to the nearest pixel edge, like in GIMP, instead of entire pixels.",
	"settings.pick_color_opacity": "Pick Color Opacity",
	"settings.pick_color_opacity.desc": "Pick the color opacity with the Color Picker and set it as brush opacity",
	"settings.paint_with_stylus_only": "Paint with Stylus Only",
	"settings.paint_with_stylus_only.desc": "Only use the stylus for painting, reserve mouse or touch input for navigation.",
	"action.copy_brush_mode": "Copy Brush Mode",
	"action.copy_brush_mode.copy": "Copy",
	"action.copy_brush_mode.pattern": "Pattern",
	"action.copy_brush_mode.sample": "Sample",
	"action.brush_shape": "Brush Shape",
	"action.brush_shape.square": "Square",
	"action.brush_shape.circle": "Circle",
	"action.blend_mode": "Blend Mode",
	"action.blend_mode.default": "Default",
	"action.blend_mode.set_opacity": "Set Opacity",
	"action.blend_mode.color": "Color",
	"action.blend_mode.behind": "Behind",
	"action.blend_mode.multiply": "Multiply",
	"action.blend_mode.divide": "Divide",
	"action.blend_mode.add": "Add",
	"action.blend_mode.subtract": "Subtract",
	"action.blend_mode.screen": "Screen",
	"action.blend_mode.overlay": "Overlay",
	"action.blend_mode.hard_light": "Hard Light",
	"action.blend_mode.difference": "Difference",
	"action.copy_brush": "Copy Brush",
	"action.copy_brush.desc": "Brush to clone parts of your texture or draw patterns. Hold Ctrl and click to select a copy source.",
	"action.validator_window": "View Model Issues...",
	"action.validator_window.desc": "Opens the validator, which lists issues with the current model.",
	"action.cancel_gif": "Cancel GIF",
	"menu.text_edit.copy_vector": "Copy Vector",
	"menu.brush_presets.dialog": "Brush Presets...",
	"menu.brush_presets.pixel_brush": "Pixel Brush",
	"menu.brush_presets.smooth_brush": "Smooth Brush",
	"menu.texture.edit_in_blockbench": "Edit in Blockbench",
	"menu.mirror_painting.axis": "Axis",
	"menu.mirror_painting.axis.desc": "Select on which axis paint strokes will get mirrored",
	"menu.mirror_painting.global": "Global Symmetry",
	"menu.mirror_painting.global.desc": "Enabled mirror painting on the model in global space",
	"menu.mirror_painting.local": "Local Symmetry",
	"menu.mirror_painting.local.desc": "Enable mirror painting in local space for each element",
	"menu.mirror_painting.texture_frames": "Repeat on Flipbook Frames",
	"menu.mirror_painting.texture_frames.desc": "Mirror paint strokes to every frame of animated textures",
	"format.bedrock_block.info.size_limit": "Size total size of a block is limited to 30 pixels in all dimensions. The limit can be off-centered in all directions by 7 pixels from the block center.",
	"format.bedrock_block.info.textures": "Multiple textures can be applied to different cubes in Blockbench, but require additional setup in the behavior pack to work correctly in-game.",
	"format.image.desc": "Edit images in the 2D image editor",
	"generic.delete_all": "Delete All",
	"message.child_model_only.open": "Open Parent",
	"message.child_model_only.open_with_textures": "Open Parent & Adopt Textures",
	"dialog.project.credit": "Credit",
	"dialog.convert_project.create_copy": "Create Copy",
	"dialog.texture.frame_time": "Frame Time",
	"dialog.texture.frame_time.desc": "Set for how long each frame will be visible, in ticks. Each tick is 1/20th of a second.",
	"dialog.texture.frame_interpolate": "Interpolate",
	"dialog.texture.frame_interpolate.desc": "Interpolate between animation frames by cross-fading to the next frame",
	"dialog.texture.frame_order_type": "Loop Mode",
	"dialog.texture.frame_order_type.loop": "Loop",
	"dialog.texture.frame_order_type.backwards": "Loop Backwards",
	"dialog.texture.frame_order_type.back_and_forth": "Back-and-Forth",
	"dialog.texture.frame_order_type.custom": "Custom Order",
	"dialog.texture.frame_order": "Frame Order",
	"dialog.texture.frame_order.desc": "Set a custom frame order by listing frame indices in a new order. Frame indices start at 0 with the first frame.",
	"dialog.select.mode": "Mode",
	"dialog.select.mode.new": "New Selection",
	"dialog.select.mode.add": "Add to Selected",
	"dialog.select.mode.remove": "Remove from Selected",
	"dialog.select.mode.in_selection": "Select only from Selected",
	"dialog.predicate_overrides.model": "Model",
	"dialog.predicate_overrides.predicates": "Predicates",
	"dialog.predicate_overrides.variants": "Variants",
	"dialog.predicate_overrides.start_value": "Start",
	"dialog.predicate_overrides.add_override": "Add Override",
	"dialog.predicate_overrides.add_predicate": "Add Predicate",
	"dialog.predicate_overrides.generate_overrides": "Generate Overrides",
	"dialog.predicate_overrides.confirm_delete": "Are you sure you want to delete all overrides?",
	"dialog.predicate_overrides.predicate.angle": "Compass Angle",
	"dialog.predicate_overrides.predicate.blocking": "Is Blocking",
	"dialog.predicate_overrides.predicate.broken": "Is Broken",
	"dialog.predicate_overrides.predicate.cast": "Is Cast",
	"dialog.predicate_overrides.predicate.cooldown": "Cooldown",
	"dialog.predicate_overrides.predicate.damage": "Damage",
	"dialog.predicate_overrides.predicate.damaged": "Is Damaged",
	"dialog.predicate_overrides.predicate.lefthanded": "Is Left-Handed",
	"dialog.predicate_overrides.predicate.pull": "Pull Amount",
	"dialog.predicate_overrides.predicate.pulling": "Is Pulling",
	"dialog.predicate_overrides.predicate.charged": "Is Charged",
	"dialog.predicate_overrides.predicate.firework": "Has Firework",
	"dialog.predicate_overrides.predicate.throwing": "Ready to Throw",
	"dialog.predicate_overrides.predicate.time": "Time of Day",
	"dialog.predicate_overrides.predicate.custom_model_data": "Custom Model Data",
	"dialog.predicate_overrides.predicate.level": "Light Level",
	"dialog.predicate_overrides.predicate.filled": "Bundle Fill Level",
	"dialog.predicate_overrides.predicate.tooting": "Tooting",
	"settings.model_export_scale": "Model Export Scale",
	"settings.model_export_scale.desc": "Factor by which the scale of exported glTF, DAE, and FBX models gets reduced. The default is 16, which converts 16 Blockbench units into 1 meter in the export.",
	"action.export_fbx": "Export FBX Model",
	"action.export_fbx.desc": "Export model and animations as fbx file to use it in other 3D applications and game engines",
	"action.center_lateral": "Center Lateral",
	"action.center_lateral.desc": "Center the selected elements on the X and Z axis",
	"action.adjust_opacity": "Adjust Opacity...",
	"action.adjust_opacity.desc": "Adjust the opacity of the selected texture",
	"action.rotate_texture_cw": "Rotate Clockwise",
	"action.rotate_texture_ccw": "Rotate Counter-clockwise",
	"action.predicate_overrides": "Edit Predicate Overrides...",
	"action.predicate_overrides.desc": "Select models to override this model based on selected conditions",
	"action.auto_set_cullfaces": "Set Cullfaces Automatically",
	"action.auto_set_cullfaces.desc": "Automatically generate cullfaces to hide faces when they are covered by the neighboring block.",
	"menu.texture.edit_externally": "Edit Externally",
	"menu.mirror_painting.texture": "2D Editor Symmetry",
	"menu.mirror_painting.texture.desc": "Enable mirror painting in 2D space on the image or texture",
	"menu.animator.rotation_global": "Rotate in Global Space",
	"uv_editor.face_properties": "Face Properties",
	"uv_editor.face_properties.material_instance": "Material Instance",
	"uv_editor.tint.info": "Tint can be enabled on a face to tell Minecraft to tint it. In vanilla, tint can only be used by specific blocks such as leaves and redstone dust, and can only have a value of 0.",
	"uv_editor.cullface.info": "Enabling cullface tells a face on a block to unrender if another full block is placed next to it in the specified direction in your Minecraft world. This can be used to optimize performance.",
	"uv_editor.material_instance.info": "Material instances can be set to a user-defined name. That name can be used in the block JSON file in the behavior pack to assign a particular texture and material that the face.",
	"display.reference.frame_invisible": "Item Frame (Invisible)",
	"data.settings_profile": "Profile",
	"message.display_skin.invalid_name": "Cannot find Minecraft account with the name \"%0\".",
	"dialog.load_plugins_from_query.title": "Load Plugins",
	"dialog.load_plugins_from_query.text": "You used a link that requires plugins to be installed. Would you like to install them?",
	"dialog.select_model.title": "Select Model",
	"dialog.select_model.bones": "Bones",
	"dialog.select_model.cubes": "Cubes",
	"dialog.settings.create_profile": "Create Profile...",
	"settings_profile.confirm_delete": "Are you sure you want to delete this settings profile?",
	"settings_profile.condition.type.selectable": "Manually Selectable",
	"settings.interface_mode": "UI Mode",
	"settings.interface_mode.desc": "Interface mode",
	"settings.interface_mode.auto": "Automatic",
	"settings.interface_mode.desktop": "Desktop",
	"settings.interface_mode.mobile": "Mobile",
	"settings.paint_through_transparency": "Paint Through Transparency",
	"settings.paint_through_transparency.desc": "Paint through transparent pixels when Lock Alpha Channel is enabled",
	"action.tab_overview": "Tab Overview",
	"action.tab_overview.desc": "View all open tabs in a grid and jump to one",
	"action.slider_color_red": "Color Red",
	"action.slider_color_green": "Color Green",
	"action.slider_color_blue": "Color Blue",
	"action.add_animation_controller": "Add Animation Controller",
	"action.add_animation_controller.desc": "Create a blank animation controller",
	"action.animation_controller_preview_mode": "Controller Preview",
	"action.animation_controller_preview_mode.paused": "Paused",
	"action.animation_controller_preview_mode.manual": "Manual Preview",
	"action.animation_controller_preview_mode.play": "Auto Play",
	"action.keyframe_interpolation.bezier": "Bézier",
	"action.keyframe_bezier_linked": "Link Bézier Handles",
	"action.keyframe_bezier_linked.desc": "Connect the right and left keyframe bézier handle",
	"action.reset_keyframe_handles": "Reset Keyframe Handles",
	"action.reset_keyframe_handles.desc": "Reset the bézier handles of the selected keyframes",
	"action.looped_animation_playback": "Looped Playback",
	"action.looped_animation_playback.desc": "Preview animations in an infinite loop",
	"timeline.bind_to_actor": "Bind to Actor",
	"animation_controllers.select_preset": "Select a controller preset...",
	"animation_controllers.state.animations": "Animations",
	"animation_controllers.state.particles": "Particles",
	"animation_controllers.state.sounds": "Sounds",
	"animation_controllers.state.on_entry": "On Entry",
	"animation_controllers.state.on_exit": "On Exit",
	"animation_controllers.state.transitions": "Transitions",
	"animation_controllers.state.condition": "Condition",
	"animation_controllers.state.blend_transition": "Blend Time",
	"animation_controllers.state.shortest_path": "Blend by Shortest Path",
	"animation_controllers.state.edit_transition": "Edit Transition",
	"menu.color_picker.picker_type": "Picker Type",
	"menu.color_picker.picker_type.square": "Square",
	"menu.color_picker.picker_type.wheel": "Wheel",
	"menu.color_picker.slider_mode": "Slider Mode",
	"menu.color_picker.slider_mode.hsv": "Hue, Saturation, Value",
	"menu.color_picker.slider_mode.rgb": "Red, Green, Blue",
	"menu.texture.render_mode.additive": "Additive",
	"panel.color.picker_options": "Color Picker Options",
	"panel.animation_controllers": "Animation Controller",
	"display.preset.armor_stand": "Ground (Armor Stand)",
	"data.file_path": "File Path",
	"dialog.extrude.orientation": "Orientation",
	"dialog.extrude.orientation.upright": "Upright",
	"dialog.extrude.orientation.flat": "Flat",
	"dialog.scale.box_uv_warning": "Scaling a Box UV model may break the UV of your model. Instead, try to scale your model externally, or switch to Per-face UV Mode in File > Project.",
	"dialog.create_gif.format": "Format",
	"dialog.create_gif.format.gif": "GIF",
	"dialog.create_gif.format.png_sequence": "PNG Sequence",
	"dialog.create_gif.pixelate": "Pixelate",
	"dialog.create_gif.bg_image": "Background Image",
	"dialog.create_gif.turn.desc": "Rotate the model while recording. Use negative values to turn the model clockwise. A value of 60 corresponds to one rotation every second.",
	"settings_profile.condition": "Condition",
	"settings_profile.condition.type.file_path.desc": "Use Regular Expression syntax to match the file path of the current project. Use forward slashes for directories",
	"settings.only_selected_bezier_handles": "Show Only Selected Bézier Handles",
	"settings.only_selected_bezier_handles.desc": "Hide handles of bézier keyframes that are not currently selected",
	"settings.embed_textures": "Embed Textures",
	"settings.embed_textures.desc": "Embed texture file content in .bbmodel files",
	"action.selection_mode.cluster": "Cluster",
	"dialog.copied_to_clipboard": "Copied to clipboard",
	"data.reference_image": "Reference Image",
	"message.delete_reference_image": "Are you sure you want to delete this reference image? This cannot be undone.",
	"message.add_reference_image.message": "Select where to load the reference image",
	"message.add_reference_image.project": "Add to this project",
	"message.add_reference_image.app": "Add to all projects",
	"message.import_particle_texture.import": "Import Particle Texture",
	"message.import_particle_texture.message": "Would you like to import a texture file to be used for your particle?",
	"message.save_codec_selector.title": "Save Model Format",
	"message.save_codec_selector.message": "Select a format to save the model in.",
	"message.save_codec_selector.project_file": "Blockbench Project (.bbmodel)",
	"message.save_codec_selector.both": "Both",
	"message.display_skin.username": "Username (Java)",
	"message.palette_locked": "The palette is locked",
	"dialog.project.default_uv_mode": "Default UV Mode",
	"dialog.project.default_uv_mode.description": "Default UV Mode of the project. The UV mode can also be changed per cube.",
	"dialog.export_options.title": "Export Options",
	"dialog.edit_texture.preview": "Preview",
	"dialog.proportional_editing.range": "Range",
	"dialog.proportional_editing.falloff": "Falloff",
	"dialog.proportional_editing.falloff.linear": "Linear",
	"dialog.proportional_editing.falloff.hermite_spline": "Smooth",
	"dialog.proportional_editing.falloff.constant": "Constant",
	"dialog.proportional_editing.selection": "Selection",
	"dialog.proportional_editing.selection.linear": "Linear Distance",
	"dialog.proportional_editing.selection.connections": "Connections",
	"dialog.mirror_painting_texture_center.middle": "Middle",
	"dialog.mirror_painting_texture_center.custom": "Custom",
	"dialog.settings.reset_to_default": "Reset to Default",
	"keybindings.item.num_slider.increase": "Increase",
	"keybindings.item.num_slider.decrease": "Decrease",
	"settings.always_show_splash_art": "Always Show Splash Art",
	"settings.always_show_splash_art.desc": "Always display the splash art on the start screen",
	"action.slider_palette_color": "Switch Palette Color",
	"action.slider_palette_color.desc": "Cycle between the colors in the palette",
	"action.proportional_editing": "Proportional Editing",
	"action.proportional_editing.desc": "Proportionally affect surrounding vertices when editing parts of a mesh",
	"action.limit_to_palette": "Limit to Palette",
	"action.limit_to_palette.desc": "Limits the colors of the texture to those in the currently loaded palette",
	"action.edit_reference_images": "Edit Reference Images",
	"action.edit_reference_images.desc": "Turn on reference image mode to add or edit reference images and blueprints",
	"action.add_reference_image": "Add Reference Image",
	"action.reference_image_from_clipboard": "Reference Image from Clipboard",
	"action.reference_image_list": "Reference Images",
	"action.connect_uv_faces": "Connect UV Faces",
	"action.connect_uv_faces.desc": "Connect the selected UV faces to the last selected UV face",
	"action.merge_uv_vertices": "Merge UV Vertices",
	"action.merge_uv_vertices.desc": "Snap the first selected UV vertices to the last selected UV vertices",
	"action.bedrock_animation_mode": "Bedrock Animation Mode",
	"action.bedrock_animation_mode.desc": "Select the mode to edit animations for Minecraft: Bedrock Edition in",
	"action.bedrock_animation_mode.entity": "Entity",
	"action.bedrock_animation_mode.attachable_first": "Item 1st Person",
	"action.bedrock_animation_mode.attachable_third": "Item 3rd Person",
	"timeline.amplify": "Amplify",
	"menu.options": "Options...",
	"menu.palette.lock_palette": "Lock Palette",
	"menu.uv.export": "Export UV Mapping",
	"menu.uv.flip_x": "Mirror X",
	"menu.uv.flip_y": "Mirror Y",
	"menu.mirror_painting.enabled": "Enabled",
	"reference_image.position": "Position",
	"reference_image.size": "Size",
	"reference_image.rotation": "Rotation",
	"reference_image.opacity": "Opacity",
	"reference_image.visibility": "Visibility",
	"reference_image.clear_mode": "Clear Mode",
	"reference_image.layer": "Layer",
	"reference_image.layer.background": "Behind Model",
	"reference_image.layer.viewport": "Above Model",
	"reference_image.layer.float": "Above Interface",
	"reference_image.scope": "Scope",
	"reference_image.scope.project": "Just this project",
	"reference_image.scope.global": "All projects",
	"reference_image.enabled_modes": "Enabled in Modes",
	"codec.common.encoding": "Encoding",
	"codec.common.armature": "Export Groups as Armature",
	"codec.common.export_animations": "Export Animations",
	"codec.common.embed_textures": "Embed Textures",
	"preview.center_camera": "Center Camera",
	"display.reference.frame_top": "Item Frame Top",
	"display.reference.frame_top_invisible": "Item Frame Top (Invisible)",
	"action.proportional_editing_range": "Proportional Editing Range",
	"action.proportional_editing_range.desc": "Adjust the range for proportional editing",
	"action.toggle_all_reference_images": "Hide/Show All Reference Images",
	"action.toggle_all_reference_images.desc": "Toggle the visibility of all reference images at once",
	"action.add_animation_controller_state": "Add Animation Controller State",
	"action.add_animation_controller_state.desc": "Add a new state to the animation controller",
	"menu.slider.round_value": "Round Value",
	"texture.error.too_large": "Resolution exceeds the maximum of %0",
	"dialog.copy_to_clipboard": "Copy to clipboard",
	"dialog.open_url": "Open URL",
	"reference_image.image": "Image",
	"uv_editor.rotate_uv": "Rotate UV",
	"generic.error": "Error",
	"projects.start_screen": "Start Screen",
	"message.invalid_link.message": "The shared model \"%0\" that you are trying to load is either invalid or has expired.",
	"message.plugin_dependencies.title": "Plugin Dependencies",
	"message.plugin_dependencies.message1": "The plugin requires these dependencies:",
	"message.plugin_dependencies.message1_update": "The plugin %0 has been updated and now requires these dependencies:",
	"message.plugin_dependencies.message2": "Do you want to install them to continue?",
	"message.plugin_dependencies.invalid": "Unfortunately the plugin cannot be installed, it has an invalid dependency:",
	"message.preview_scene_load_failed": "Failed to load preview scene. Check your internet connection.",
	"dialog.convert_project.text1": "Convert the project into a different format.",
	"dialog.convert_project.text2": "Use conversion at your own risk. Formats have different features and restrictions, so converting will in some cases break parts of your project.",
	"dialog.convert_project.text3": "You cannot undo converting, that is why by default a copy will be created.",
	"dialog.unsaved_work.title": "Unsaved Work",
	"dialog.unsaved_work.text": "The following projects contain unsaved changes. Do you want to save your changes?",
	"dialog.unsaved_work.discard_all": "Discard All",
	"dialog.unsaved_work.save_all": "Save All",
	"dialog.resize_texture.mode": "Mode",
	"dialog.resize_texture.mode.crop": "Crop/Expand",
	"dialog.resize_texture.mode.scale": "Scale",
	"dialog.plugins.is_installed": "Installed",
	"dialog.plugins.is_disabled": "Disabled",
	"dialog.plugins.disable": "Disable",
	"dialog.plugins.enable": "Enable",
	"dialog.plugins.dependencies": "Depends on:",
	"dialog.view_backups.open_folder": "Open Folder",
	"dialog.share_model.reference_images": "Include Reference Images",
	"dialog.share_model.too_large": "Failed to upload: Model is too large",
	"dialog.share_model.too_large_references": "Failed to upload: Model is too large. Try without reference images.",
	"settings.stretch_linked": "Link Stretching",
	"settings.stretch_linked.desc": "Stretch the cube in all directions with the same value",
	"settings.grids": "Show Grids",
	"settings.grids.desc": "Show or hide all 3D grids",
	"settings.double_click_switch_tools": "Switch Tools on Double Click",
	"settings.double_click_switch_tools.desc": "Double click the viewport to switch between tools",
	"settings.outlines_in_paint_mode": "Selection Outlines in Paint Mode",
	"settings.outlines_in_paint_mode.desc": "Display element selection outlines while in paint mode",
	"settings.json_indentation": "JSON Indentation",
	"settings.json_indentation.desc": "Indentation style for exported JSON files",
	"settings.json_indentation.tabs": "Tabs",
	"settings.json_indentation.spaces_4": "Spaces: 4",
	"settings.json_indentation.spaces_2": "Spaces: 2",
	"action.slider_stretch": "Stretch",
	"action.slider_stretch.desc": "Stretches cubes multiplicatively on the %0 axis without changing the UV",
	"action.view_backups": "View Backups",
	"action.view_backups.desc": "Browse the list of auto-saved project backups",
	"action.search_outliner": "Search Outliner",
	"action.search_outliner.desc": "Search for specific element names in the outliner",
	"action.mirror_modeling": "Mirror Modeling",
	"action.mirror_modeling.desc": "Enable Mirror Modeling on the X axis. All changes you make in the viewport will be reflected to the other side, unless specifically disabled on the element.",
	"action.allow_element_mirror_modeling": "Allow Mirror Modeling",
	"action.allow_element_mirror_modeling.desc": "Choose whether the selected elements can be affected by mirror modeling",
	"action.switch_face_crease": "Switch Face Crease",
	"action.switch_face_crease.desc": "Switch in which direction the quad folds in the middle",
	"action.clear_unused_texture_space": "Clear Unused Texture Space",
	"action.clear_unused_texture_space.desc": "Clear parts of the texture that are not UV-mapped to any elements",
	"action.split_screen": "Split Screen",
	"action.split_screen.desc": "Select a viewport split screen mode",
	"action.split_screen.single": "Single",
	"action.split_screen.double_horizontal": "Double Horizontal",
	"action.split_screen.double_vertical": "Double Vertical",
	"action.split_screen.quad": "Quad",
	"action.split_screen.triple_left": "Triple Left",
	"action.split_screen.triple_right": "Triple Right",
	"action.split_screen.triple_top": "Triple Top",
	"action.split_screen.triple_bottom": "Triple Bottom",
	"action.uv_project_from_view": "UV Project from View",
	"action.uv_project_from_view.desc": "Automatically generate UVs for the selected faces from the perspective of the 3D view",
	"action.graph_editor_other_graphs": "Display Other Graphs",
	"action.graph_editor_other_graphs.desc": "Whether the graphs of the axes that are not selected are displayed",
	"action.graph_editor_include_other_graphs": "Include Other Graphs",
	"action.graph_editor_include_other_graphs.desc": "Whether the graph editor includes the graphs that are not selected in the view",
	"action.set_ik_source": "Set IK Root",
	"action.set_ik_source.desc": "Select the root bone of the chain that should be moved by this null object via Inverse Kinematics",
	"edit.loop_cut.cuts": "Cuts",
	"panel.element.stretch": "Stretch",
	"preview_scene.minecraft_plains": "Plains",
	"preview_scene.minecraft_cherry_grove": "Cherry Grove",
	"preview_scene.minecraft_snowy_tundra": "Snowy Tundra",
	"preview_scene.minecraft_sunset": "Sunset",
	"preview_scene.minecraft_night": "Night",
	"preview_scene.minecraft_desert": "Desert",
	"preview_scene.minecraft_underwater": "Underwater",
	"preview_scene.minecraft_coral_reef": "Coral Reef",
	"preview_scene.minecraft_lush_cave": "Lush Cave",
	"preview_scene.minecraft_deep_dark": "Deep Dark",
	"generic.navigate_forward": "Forward",
	"generic.navigate_back": "Back",
	"action.element_render_order": "Transparency Render Order",
	"action.element_render_order.default": "Auto",
	"action.element_render_order.behind": "Behind",
	"action.element_render_order.in_front": "In Front",
	"message.installing_update.title": "Update Available",
	"message.installing_update.message": "A new version is ready to be installed. After closing the app, please allow for around %0 seconds before opening Blockbench again or turning off the computer, for the update to be installed.",
	"settings.brush_cursor_2d": "2D Brush Cursor",
	"settings.brush_cursor_2d.desc": "Display an outline around the brush in the 2D workspace",
	"settings.brush_cursor_3d": "3D Brush Cursor",
	"settings.brush_cursor_3d.desc": "Display an outline around the brush in the 3D workspace",
	"settings.cdn_mirror": "Use CDN Mirror",
	"settings.cdn_mirror.desc": "Use the mirror CDN to download plugins. The mirror receives updates faster and works in some regions where the default does not work.",
	"data.layer": "Layer",
	"data.panel": "Panel",
	"generic.confirm_delete": "Are you sure you want to delete this?",
	"format_category.general": "General",
	"modifier_actions.no_uniform_scaling": "Free Scaling",
	"message.texture_refresh_conflict.title": "Conflicting Texture Versions",
	"message.texture_refresh_conflict.message": "The texture file might contain changes that conflict with Blockbench's version",
	"message.texture_refresh_conflict.keep_ours": "Keep Blockbench's version",
	"message.texture_refresh_conflict.keep_theirs": "Load file and discard all changes and layers in Blockbench",
	"message.group_required_to_animate": "You cannot animate this type of element. Create a group or armature to animate it.",
	"dialog.texture.uv_size": "UV Size",
	"dialog.advanced_screenshot.angle_preset": "Angle Preset",
	"dialog.advanced_screenshot.resolution": "Resolution",
	"dialog.advanced_screenshot.zoom_to_fit": "Zoom To Fit",
	"dialog.advanced_screenshot.zoom": "Zoom / Focal Length",
	"dialog.advanced_screenshot.anti_aliasing": "Anti-aliasing",
	"dialog.advanced_screenshot.anti_aliasing.off": "Off",
	"dialog.advanced_screenshot.anti_aliasing.msaa": "Multisampling",
	"dialog.advanced_screenshot.anti_aliasing.ssaa": "Supersampling",
	"dialog.advanced_screenshot.show_gizmos": "Show Edit Gizmos",
	"dialog.advanced_screenshot.shading": "Shading",
	"settings.auto_keyframe": "Auto Keyframe",
	"settings.auto_keyframe.desc": "Automatically create a keyframe with default values at the timeline start when transforming the bone at a later point",
	"settings.modded_entity_integer_size": "Modded Entity Integer Size",
	"settings.modded_entity_integer_size.desc": "Limit cube sizes in the Modded Entity format to integers. While floats are technically supported in some versions, integers are much easier to UV-map.",
	"category.layers": "Layers",
	"keybind.paint_secondary_color": "Paint with Secondary Color",
	"action.selection_tool_operation_mode": "Selection Operation Mode",
	"action.selection_tool_operation_mode.create": "New Selection",
	"action.selection_tool_operation_mode.add": "Add to Selection",
	"action.selection_tool_operation_mode.subtract": "Subtract from Selection",
	"action.selection_tool_operation_mode.intersect": "Intersect",
	"action.pixel_perfect_drawing": "Pixel Perfect Drawing",
	"action.pixel_perfect_drawing.desc": "Draw smooth pixel-art lines without double pixels at curves",
	"action.selection_tool": "Selection Tool",
	"action.selection_tool.desc": "Select parts of the image",
	"action.selection_tool.rectangle": "Rectangle",
	"action.selection_tool.ellipse": "Ellipse",
	"action.selection_tool.lasso": "Lasso Select",
	"action.selection_tool.wand": "Magic Wand",
	"action.selection_tool.color": "Same Color",
	"action.move_layer_tool": "Move Layer",
	"action.move_layer_tool.desc": "Move the current layer or selection",
	"action.export_modded_animations": "Export Modded Entity Animations",
	"action.export_modded_animations.desc": "Export animations for a Minecraft Java Edition modded entity model",
	"action.swap_colors": "Swap Colors",
	"action.swap_colors.desc": "Swap the main color with the secondary color",
	"action.apply_mesh_rotation": "Apply Rotation",
	"action.apply_mesh_rotation.desc": "Reset the element rotation of the mesh, and apply it to the geometry instead",
	"action.flip_texture_x.desc": "Flip the texture or layer horizontally",
	"action.flip_texture_y.desc": "Flip the texture or layer vertically",
	"action.rotate_texture_cw.desc": "Rotate the texture or layer clockwise",
	"action.rotate_texture_ccw.desc": "Rotate the texture or layer counter-clockwise",
	"action.crop_texture_to_selection": "Crop Texture to Selection",
	"action.create_empty_layer": "Create Empty Layer",
	"action.enable_texture_layers": "Enable Layers",
	"action.disable_texture_layers": "Disable Layers",
	"action.layer_opacity": "Layer Opacity",
	"action.layer_to_texture_size": "Expand Layer to Texture Size",
	"action.layer_to_texture_size.desc": "Expand the layer to the size of the texture",
	"action.merge_layer_down": "Merge Down",
	"action.merge_layer_down.desc": "Merge into the layer below",
	"action.advanced_screenshot": "Advanced Screenshot...",
	"action.advanced_screenshot.desc": "Take a screenshot of the model with advanced options",
	"action.bake_ik_animation": "Bake Inverse Kinematics",
	"action.bake_ik_animation.desc": "Bake the rotations applied by inverse kinematics into the selected animation",
	"action.save_animation_preset": "Save Animation Preset...",
	"action.save_animation_preset.desc": "Save the selected keyframes as an animation preset",
	"action.animation_onion_skin": "Animation Onion Skin",
	"action.animation_onion_skin.desc": "Display an wireframe view of a different frame in the animation for reference",
	"action.apply_animation_preset": "Apply Animation Preset",
	"action.apply_animation_preset.desc": "Select from a list of animation presets and apply it to the selected bone",
	"menu.brush_presets.pixel_perfect": "Pixel-perfect Brush",
	"panel.layers": "Layers",
	"uv_editor.copy_paste_tool.to_layer": "To New Layer",
	"format.image.new": "Create New Image",
	"format.image.info.summary": "The 2D Image editor lets you create and edit images and pixel art directly in Blockbench, without the need for an external image editor. Edit images, modify textures, or create your own pixel art!",
	"settings.move_with_selection_tool": "Use Selection Tool to Move Selections",
	"settings.move_with_selection_tool.desc": "Allow the Selection Tool to directly move selections, without having to switch to the Move Layer tool",
	"settings.final_newline": "Final Newline",
	"settings.final_newline.desc": "Insert a newline character at the end of exported files",
	"action.crop_layer_to_selection": "Crop Layer to Selection",
	"action.edit_mode_uv_overlay.desc": "Display the UV map overlay for all elements in edit mode",
	"menu.image": "Image",
	"menu.texture.discard_changes": "Discard Changes",
	"menu.texture.discard_changes.desc": "Discard all unsaved changes and load the latest version from the file",
	"panel.textures.images": "Images",
	"dialog.advanced": "Advanced",
	"dialog.recommended_option": "recommended",
	"modifier_actions.snap_to_center": "Snap to Center",
	"modifier_actions.snap_to_pixels": "Snap to Pixels",
	"message.invalid_format.install_plugin": "Install plugin '%0'",
	"message.plugin_deprecated.message": "Are you sure you want to install this deprecated plugin?",
	"message.plugin_deprecated.install_anyway": "Install Anyway",
	"message.image_editor.not_found": "Could not find the selected image editor. Please select a different option.",
	"message.knife_tool.confirm": "Press %0 or click here to apply Knife Tool",
	"message.knife_tool.skipped_face": "Cannot cut between different faces. Include the edges or vertices between them!",
	"message.optimize_animation.keyframes_removed": "Removed %0 redundant keyframes",
	"message.optimize_animation.nothing_to_optimize": "Found nothing to optimize!",
	"message.duplicate_bone_copy_animation.title": "Copy Animation",
	"message.duplicate_bone_copy_animation.message": "The duplicated bone is animated in %0 animations. Do you want to copy the keyframes over to the new bone?",
	"message.auto_fix_mesh_edit.title": "Auto Fix",
	"message.auto_fix_mesh_edit.revert": "Revert Edit",
	"message.auto_fix_mesh_edit.overlapping_vertices": "Certain vertices have been moved into the same spot. How would you like to proceed?",
	"message.auto_fix_mesh_edit.concave_quads": "One or more quad faces are now concave, which can cause issues in UV-mapping and rendering. Blockbench can automatically fix it for you:",
	"message.auto_fix_mesh_edit.merge_vertices": "Merge Vertices",
	"message.auto_fix_mesh_edit.split_quads": "Split Quads",
	"message.load_images.add_image": "Add Image",
	"dialog.project.modded_entity_entity_class": "Entity Class",
	"dialog.resize_texture.offset": "Offset",
	"dialog.animated_texture_editor.code_reference": "Code Reference",
	"dialog.animated_texture_editor.code_reference.about": "This code to implement the texture animation was generated as a reference and does not necessarily work without modification. Check out the documentation to learn more.",
	"dialog.animated_texture_editor.code_reference.docs": "Documentation",
	"dialog.animated_texture_editor.reframe": "Reframe",
	"dialog.animated_texture_editor.stride": "Frame Size",
	"dialog.animated_texture_editor.frames": "Number of Frames",
	"dialog.animated_texture_editor.add_frame": "Add Frame",
	"dialog.animated_texture_editor.resize_frames": "Resize Frames...",
	"dialog.animated_texture_editor.apply": "Apply",
	"dialog.add_primitive.edge_size": "Edge Size",
	"dialog.change_animation_speed.speed": "Speed",
	"dialog.change_animation_speed.adjust_snapping": "Adjust Snapping",
	"dialog.optimize_animation.selection": "Selection",
	"dialog.optimize_animation.selection.selected_keyframes": "Selected Keyframes",
	"dialog.optimize_animation.selection.selected_animation": "Selected Animation",
	"dialog.optimize_animation.selection.all_animations": "All Animations",
	"dialog.optimize_animation.thresholds": "Threshold values",
	"dialog.import_obj.obj": "OBJ File",
	"dialog.import_obj.mtl": "MTL File",
	"dialog.import_obj.scale": "Scale",
	"layout.thumbnail": "Custom Thumbnail CSS",
	"settings.pixel_grid": "Pixel Grid",
	"settings.pixel_grid.desc": "Show texture pixel grid on elements in edit mode",
	"settings.image_editor_grid_size": "Image Editor Grid Size",
	"settings.image_editor_grid_size.desc": "Size of the large grid in the 2D image editor",
	"settings.ground_plane_double_side": "Ground Plane Double-sided",
	"settings.ground_plane_double_side.desc": "Make the ground plane visible from below",
	"settings.optifine_save_default_texture": "OptiFine JEM: Export selected texture",
	"settings.optifine_save_default_texture.desc": "Export the selected texture as the default texture of the model",
	"action.slider_color_select_threshold": "Color Select Threshold",
	"action.slider_color_select_threshold.desc": "How close the color of a neighboring pixel has to be to get selected by color or wand select",
	"action.stretch_tool": "Stretch",
	"action.stretch_tool.desc": "Tool to select and stretch elements",
	"action.knife_tool": "Knife Tool",
	"action.knife_tool.desc": "Tool to cut mesh faces into smaller pieces",
	"action.duplicate_project": "Duplicate Project",
	"action.duplicate_project.desc": "Creates a copy of the open project",
	"action.transform_space.parent": "Parent",
	"action.transform_pivot_space": "Pivot Transform Space",
	"action.solidify_mesh_selection": "Solidify Faces",
	"action.solidify_mesh_selection.desc": "Solidify the selected faces of the mesh",
	"action.animated_texture_editor": "Flipbook Editor...",
	"action.animated_texture_editor.desc": "Edit the flipbook animation of the selected texture",
	"action.center_individual_pivots": "Center Individual Pivots",
	"action.center_individual_pivots.desc": "Set the pivot point of each selected element to its center",
	"action.uv_cycle": "Cycle UV",
	"action.uv_cycle.desc": "Cycle through the order of UV vertices without changing the UV positions",
	"action.uv_cycle_invert": "Cycle Invert UV",
	"action.uv_cycle_invert.desc": "Reverse the order of UV vertices without changing the UV positions",
	"action.slider_animation_controller_speed": "Controller Playback Speed",
	"action.slider_animation_controller_speed.desc": "The playback speed of animation controllers in percent",
	"action.optimize_animation": "Optimize Animation",
	"action.optimize_animation.desc": "Optimize the current animation and reduce the keyframe count",
	"action.change_animation_speed": "Change Animation Speed...",
	"action.change_animation_speed.desc": "Change the speed of the selected animation",
	"timeline.select_particle_file": "Select Particle File",
	"timeline.select_sound_file": "Select Sound File",
	"menu.cube.texture.default": "Default",
	"menu.texture.particle.clear": "Stop using for Particles",
	"menu.texture.use_as_default": "Set as Default",
	"menu.texture.use_as_default.clear": "Unassign as Default",
	"menu.toolbar.overflow": "Toolbar Overflow",
	"edit.solidify_mesh_selection.thickness": "Thickness",
	"reference_image.sync_to_timeline": "Sync To Timeline",
	"reference_image.toggle_playback": "Play/Pause",
	"dialog.add_primitive.shape.beveled_cuboid": "Beveled Cuboid",
	"dialog.ignore_all": "Ignore All",
	"data.texture_group": "Texture Group",
	"data.animation": "Animation",
	"generic.on": "On",
	"generic.off": "Off",
	"format.free.info.3d_printing": "3D Printing",
	"message.invalid_file.merge_conflict": "The file contains unresolved Git merge conflicts.",
	"dialog.expand_texture_selection.radius": "Amount",
	"dialog.expand_texture_selection.corner": "Corner Shape",
	"dialog.expand_texture_selection.corner.round": "Round",
	"dialog.expand_texture_selection.corner.square": "Square",
	"dialog.expand_texture_selection.corner.manhattan": "Manhattan",
	"dialog.merge_animation.merge_target": "Merge into",
	"keybindings.variation_conflict": "Variation conflicts with the main keybinding",
	"settings.recovery_save_interval": "Recovery Point Save Interval",
	"settings.recovery_save_interval.desc": "Blockbench regularly saves the open project in the background to recover in case of a computer crash. Set the interval in seconds. Set to 0 to disable saving.",
	"settings.save_view_per_tab": "Save View per Tab",
	"settings.save_view_per_tab.desc": "Save the current view angle for each tab separately",
	"settings.inherit_parent_color": "Inherit Parent Color",
	"settings.inherit_parent_color.desc": "Set the marker color of a newly created element to the color of the parent instead of a random color",
	"keybind.preview_select.multi_select": "Multi-select",
	"keybind.preview_select.group_select": "Group-select",
	"keybind.preview_select.loop_select": "Loop-select",
	"action.fill_mode.selection": "Selection",
	"action.fill_mode.selected_elements": "Selected Elements",
	"action.image_tiled_view": "Tiled View",
	"action.image_tiled_view.description": "Enable the tiled view in the 2D editor",
	"action.image_onion_skin_view": "Image Editor Onion Skin",
	"action.image_onion_skin_view.description": "Enable the onion skin view in the 2D editor",
	"action.expand_texture_selection": "Expand Texture Selection",
	"action.expand_texture_selection.desc": "Expand or shrink the texture selection",
	"action.switch_tabs.reverse_order": "Reverse order",
	"action.save_project_incremental": "Save Project With Increment",
	"action.save_project_incremental.desc": "Saves the current model as a project file with an increment (ex: project_2.bbmodel)",
	"action.copy.multiple": "Copy All",
	"action.copy.multiple.desc": "Copy all available data individually",
	"action.paste.multiple": "Paste All",
	"action.randomize_marker_colors": "Randomize Marker Colors",
	"action.cube_light_emission": "Light Emission",
	"action.cube_light_emission.desc": "Change the emissiveness of the selected cubes, as a value between 0 and 15",
	"action.view_mode.colored_solid": "Solid with Marker Colors",
	"action.focus_on_selection.rotate_only": "Rotate only",
	"action.create_texture_group": "Create Texture Group",
	"action.create_texture_group.desc": "Create a group for your textures",
	"action.uv_maximize.all_faces": "Affect all faces",
	"action.retarget_animators": "Retarget Animations",
	"action.retarget_animators.desc": "Select which animator targets which bone or element",
	"action.merge_animation": "Merge Animation",
	"action.merge_animation.desc": "Merge the animation into another animation",
	"action.add_keyframe.reset_values": "With default values",
	"action.set_timeline_range_start": "Set Timeline Range Start",
	"action.set_timeline_range_start.desc": "Set the start point for a custom playback range in the animation timeline",
	"action.set_timeline_range_end": "Set Timeline Range End",
	"action.set_timeline_range_end.desc": "Set the end point for a custom playback range in the animation timeline",
	"action.disable_timeline_range": "Disable Timeline Range",
	"action.disable_timeline_range.desc": "Disable the custom playback range in the animation timeline",
	"menu.texture_group.resolve": "Resolve",
	"menu.image_tiled_view.mirrored": "Mirrored Edges",
	"menu.image_onion_skin_view.frame": "Frames",
	"menu.image_onion_skin_view.frame.last_viewed": "Last Viewed Frame",
	"menu.image_onion_skin_view.frame.previous": "Previous Frame",
	"menu.image_onion_skin_view.frame.next": "Next Frame",
	"menu.image_onion_skin_view.frame.both": "Previous + Next",
	"menu.image_onion_skin_view.display": "Display",
	"menu.image_onion_skin_view.display.pixels": "Smaller Pixels",
	"menu.image_onion_skin_view.display.transparent": "Transparent",
	"menu.image_onion_skin_view.above": "Display Above",
	"menu.animation.reload": "Reload",
	"switches.autouv.alt": "Relative",
	"display.rotation_pivot": "Rotation Pivot",
	"display.scale_pivot": "Scale Pivot",
	"display.reference.fox": "Fox",
	"display.reference.eating": "Eating",
	"preview_scene.sky": "Sky",
	"preview_scene.space": "Space",
	"preview_scene.minecraft_ocean": "Ocean",
	"message.import_palette.selection_only": "Selection only",
	"dialog.blend_transition_edit.ease_in_out": "Ease-in-out (%0)",
	"dialog.blend_transition_edit.generate": "Generate...",
	"dialog.blend_transition_edit.generate.learn_more": "More info and preview",
	"dialog.blend_transition_edit.generate.curve": "Easing Type",
	"dialog.blend_transition_edit.generate.steps": "Keyframes",
	"settings.fps_limit": "FPS Limit",
	"settings.fps_limit.desc": "Limit how many frames per second Blockbench renders. The actual frame rate is limited to what your device can display.",
	"settings.outliner_reveal_on_select": "Reveal Elements on Select",
	"settings.outliner_reveal_on_select.desc": "Reveal elements in the ouliner when selected",
	"settings.java_export_pivots": "Export Pivots in Java block/item models",
	"settings.java_export_pivots.desc": "Save pivot points in Java block/item models on cubes without rotation",
	"animation_controllers.state.blend_transition_curve": "Blend Transition Curve",
	"menu.slider.reset_vector": "Reset Vector",
	"dialog.blend_transition_edit.extended": "Extended Graph",
	"message.screenshot_too_large.title": "Screenshot Resolution Issue",
	"message.screenshot_too_large.message": "The screenshot could not be rendered successfully. Please try again with a lower resolution or without supersampling.",
	"message.rename_elements.numbering": "You can use special characters to generate sequential numbers: % to get the index of the element within its group, $ to get the index within the selection.",
	"generic.edit_externally": "Edit Externally",
	"message.settings_require_restart.title": "Restart Required",
	"message.settings_require_restart.message": "Some settings will only apply after restarting the program.",
	"message.settings_require_restart.restart_now": "Restart Now",
	"message.settings_require_restart.restart_later": "Restart Later",
	"message.classroom_mode.install_plugin": "Cannot install plugins in Classroom Mode",
	"dialog.collection.export_path": "Export Path",
	"dialog.collection.select_all": "Select All",
	"dialog.collection.select_none": "Select None",
	"dialog.collection.add_with_filter": "Add with Filter",
	"dialog.collection.remove": "Remove",
	"dialog.material_config.title": "Material Config",
	"dialog.material_config.color_value": "Color Value",
	"dialog.material_config.mer": "Metal-Emissive-Roughness",
	"dialog.material_config.mer_value": "MER Value",
	"dialog.material_config.depth_type": "Depth Type",
	"dialog.create_texture.disable_mirror_uv": "Disable UV Mirroring",
	"dialog.create_texture.disable_mirror_uv.desc": "Disable the UV Mirror option in Mirror Modeling to preserve separate UVs for each side of the model",
	"dialog.create_gif.turn.sync_to_anim_length": "Sync to animation length",
	"settings.category.controls": "Controls",
	"settings.classroom_mode": "Classroom Mode",
	"settings.classroom_mode.desc": "Restricts functionality such as installing plugins and removes links to social media",
	"settings.antialiasing_bleed_fix": "Fix anti-aliasing bleeding",
	"settings.antialiasing_bleed_fix.desc": "Fixes texture bleeding when using anti-aliasing. Potentially unsupported on older hardware.",
	"settings.tone_mapping": "Tone Mapping",
	"settings.tone_mapping.desc": "Approximation method for displaying high dynamic range on a standard screen for PBR rendering.",
	"settings.audio_scrubbing": "Timline Scrubbing Audio",
	"settings.audio_scrubbing.desc": "Play short previews of the audio while scrubbing through time timeline",
	"settings.viewport_rotate_speed": "Viewport Rotate Speed",
	"settings.viewport_rotate_speed.desc": "Input sensitivity when rotating in the viewport",
	"settings.viewport_zoom_speed": "Viewport Zoom Speed",
	"settings.viewport_zoom_speed.desc": "Input sensitivity when zooming in the viewport",
	"settings.editor_2d_zoom_speed": "2D Editor Zoom Speed",
	"settings.editor_2d_zoom_speed.desc": "Input sensitivity when zooming in the UV and 2D paint editor",
	"category.select": "Select",
	"action.vertex_snap_mode.rotate": "Rotate",
	"action.export_image": "Export Image",
	"action.export_image.desc": "Export your texture as an image file",
	"action.apply_mirror_modeling": "Apply Mirror Modeling",
	"action.apply_mirror_modeling.desc": "Apply Mirror Modeling to the selection. All selected elements will be copied and flipped across the X axis.",
	"action.create_collection": "Create Collection",
	"action.create_collection.desc": "Create a collection out of the outliner selection",
	"action.set_collection_content_to_selection": "Set Collection Content to Selected",
	"action.set_collection_content_to_selection.desc": "Set the selected groups and elements as the content of the collection",
	"action.add_to_collection": "Add Selected to Collection",
	"action.add_to_collection.desc": "Add the selected groups and elements to the collection",
	"action.view_mode.material": "Material Preview",
	"action.create_material": "Create Material",
	"action.create_material.desc": "Create a new PBR material out of the selected texture",
	"action.generate_pbr_map": "Generate PBR Map...",
	"action.generate_pbr_map.desc": "Generate a PBR map (height map or metalness, emissiveness, roughness) from an existing texture",
	"menu.tools.main_tools": "Toolbox",
	"menu.view.panels": "Panels",
	"menu.texture.pbr_channel": "PBR Channel",
	"menu.texture.pbr_channel.color": "Color",
	"menu.texture.pbr_channel.normal": "Normal",
	"menu.texture.pbr_channel.height": "Height",
	"menu.texture.pbr_channel.mer": "MER (Metalness-Emissive-Roughness)",
	"menu.texture.pbr_channel.mer_subsurface": "MER Subsurface",
	"menu.collection.export_project": "Export Project",
	"menu.collection.export_as": "Export as \"%0\"",
	"menu.panel.enable": "Enable",
	"menu.panel.move_to": "Move To",
	"menu.panel.move_to.left_bar": "Left Sidebar",
	"menu.panel.move_to.right_bar": "Right Sidebar",
	"menu.panel.move_to.top": "Top",
	"menu.panel.move_to.bottom": "Bottom",
	"menu.panel.move_to.float": "Float",
	"menu.panel.move_to.hidden": "Hide",
	"menu.panel.fold": "Collapse",
	"menu.mirror_painting.texture_center": "Origin",
	"menu.mirror_modeling.mirror_uv": "Mirror UV",
	"menu.animation_onion_skin.frames": "Frames",
	"menu.animation_onion_skin.select": "Select",
	"menu.animation_onion_skin.previous": "Previous",
	"menu.animation_onion_skin.next": "Next",
	"menu.animation_onion_skin.previous_next": "Previous + Next",
	"menu.animation_onion_skin.count": "Count",
	"menu.animation_onion_skin.interval": "Interval",
	"menu.animation_onion_skin_selective": "Selective Onion Skin",
	"menu.animation_onion_skin_selective.desc": "Only display onion skin for the selected part of the model",
	"edit.loop_cut.unit": "Unit",
	"edit.loop_cut.unit.size_units": "Size Units",
	"edit.loop_cut.unit.percent": "Percent",
	"edit.extrude_mesh_selection.direction": "Direction",
	"edit.extrude_mesh_selection.direction.outwards": "Outwards",
	"edit.extrude_mesh_selection.direction.average": "Average",
	"edit.extrude_mesh_selection.even_extend": "Even Extend",
	"edit.vertex_snap.align": "Align",
	"edit.vertex_snap.align.longest": "Longest Axis",
	"edit.vertex_snap.align.direction": "Direction from Pivot",
	"edit.vertex_snap.align.align_axis": "%0 Axis",
	"edit.vertex_snap.ignore_axis": "Ignore Axis",
	"codec.common.format": "Format",
	"codec.image.quality": "Quality",
	"panel.collections": "Collections",
	"modifier_actions.always": "Always Enabled",
	"modifier_actions.unless": "Unless %0",
	"settings.undo_selections": "Undo Selection",
	"settings.undo_selections.desc": "Track selection changes as a step in the undo history",
	"action.focus_on_selection.zoom": "Zoom to fit",
	"display.reference.tooting": "Horn Tooting",
	"settings.selection_tolerance": "Selection Tolerance",
	"settings.selection_tolerance.desc": "Size of the area that can be clicked to select an edge or vertex",
	"action.delete.keep_vertices": "Keep Edges/Vertices",
	"menu.mesh": "Mesh",
	"dialog.material_config.subsurface": "Subsurface Scattering",
	"dialog.material_config.subsurface_enabled.desc": "Use the MER map alpha channel for subsurface scattering",
	"settings.pick_combined_color": "Pick Combined Color",
	"settings.pick_combined_color.desc": "Pick the combined color of all layers at the respective pixel, instead of the color on the active layer",
	"action.split_rgb_into_layers": "Split RGBA Channels into Layers",
	"action.split_rgb_into_layers.desc": "Split the texture into additive layers, one for each RGBA channel",
	"dialog.project.java_block_version": "Format Version",
	"data.spline_mesh": "Spline",
	"data.billboard": "Billboard",
	"data.armature": "Armature",
	"data.armature_bone": "Armature Bone",
	"generic.reload": "Reload",
	"modifier_actions.subtract": "Subtract",
	"modifier_actions.reduced_intensity": "Fine-Tune",
	"modifier_actions.select_bone": "Select Bone",
	"modifier_actions.spline_select_multiple_points": "Select multiple Points or Handles",
	"modifier_actions.move_panel_without_docking": "Move without docking",
	"message.save_all_textures.message": "Do you want to save each of the following textures?",
	"message.save_all_textures.skip": "Skip",
	"dialog.add_spline.shape": "Shape",
	"dialog.add_spline.shape.segment": "Segment",
	"dialog.add_spline.shape.square": "Rectangle",
	"dialog.add_spline.shape.circle": "Circle",
	"dialog.add_spline.diameter": "Diameter",
	"dialog.add_spline.sides_tubular": "Tube Segments",
	"dialog.add_spline.sides_radial": "Ring Segments",
	"dialog.add_spline.radius": "Tube Radius",
	"dialog.add_spline.length": "Length",
	"dialog.add_spline.width": "Width",
	"dialog.plugins.revoke_permissions": "Revoke Permissions",
	"dialog.expression_editor.pretty_print": "Pretty Print",
	"dialog.expression_editor.minify": "Minify",
	"dialog.expression_editor.find_replace": "Find/Replace",
	"dialog.create_gif.show_gizmos": "Record Gizmos & Grid",
	"dialog.preview_options.title": "Preview Options",
	"dialog.preview_options.background": "Background",
	"dialog.preview_options.background.checkerboard": "Checkerboard",
	"dialog.preview_options.background.solid": "Solid",
	"dialog.preview_options.background.custom_color": "Custom Color",
	"dialog.preview_options.show_gizmos": "Show Gizmos",
	"dialog.skin.texture_source": "Texture Source",
	"dialog.skin.texture_source.template": "Generate Template",
	"dialog.skin.texture_source.load_texture": "Load from Minecraft",
	"dialog.skin.texture_file": "Texture File",
	"dialog.convert_skin.adjust_texture": "Adjust Texture",
	"dialog.settings.clear_profile_value": "Clear profile value",
	"layout.section.customize": "Customize",
	"layout.theme.configure": "Configure",
	"layout.color.elevated": "Elevated",
	"layout.color.elevated.desc": "Elevated UI elements, usually separated by drop shadow",
	"layout.file.watch_changes": "Watch Changes and Reload",
	"settings.autocomplete_code": "Autocomplete Code",
	"settings.autocomplete_code.desc": "Display autocomplete suggestions in code editors",
	"settings.detect_flipbook_textures": "Detect Flipbook Textures",
	"settings.detect_flipbook_textures.desc": "Automatically detect flipbook animated textures and preview them as animation",
	"settings.double_click_select_reference": "Select Reference Image on Double Click",
	"settings.double_click_select_reference.desc": "Double click the viewport to select a reference image",
	"settings.default_keyframe_interpolation": "Default Keyframe Interpolation",
	"settings.default_keyframe_interpolation.desc": "Select the default keyframe interpolation mode",
	"settings.color_picker_style": "Color Picker Style",
	"settings.color_picker_style.desc": "Select the style of the paint mode color picker",
	"settings.export_asset_paths": "Export Asset Paths",
	"settings.export_asset_paths.desc": "Select how paths to assets such as textures or animations get saved in .bbmodel files",
	"settings.export_asset_paths.relative": "Relative Paths",
	"settings.export_asset_paths.absolute": "Full Paths",
	"settings.export_asset_paths.both": "Relative & Full Paths (Texture only)",
	"settings.export_asset_paths.none": "No Export",
	"action.slider_spline_resolution": "Spline Resolution %0",
	"action.slider_spline_resolution.desc": "Change spline resolution on the %0 axis (%1)",
	"action.slider_spline_resolution.u.desc_precision": "Ring Segments",
	"action.slider_spline_resolution.v.desc_precision": "Tube Segments",
	"action.slider_spline_radius": "Spline Radius",
	"action.slider_spline_radius.desc": "Change spline Radius",
	"action.slider_spline_handle_tilt": "Handle Tilt",
	"action.slider_spline_handle_tilt.desc": "Change spline handle Tilt",
	"action.slider_spline_handle_size": "Handle Size",
	"action.slider_spline_handle_size.desc": "Change spline handle Size",
	"action.blend_mode.lighten": "Lighten",
	"action.blend_mode.darken": "Darken",
	"action.weight_brush": "Weight Brush",
	"action.weight_brush.desc": "Paint vertex weights on meshes for armature deformations",
	"action.convert_minecraft_skin_variant": "Convert Slim/Wide Skin",
	"action.convert_minecraft_skin_variant.desc": "Switch the skin model between the classic wide (steve) model and the slim (alex) model. Optionally auto-adjust the texture to fit the model",
	"action.custom_skin_poses": "Custom Skin Poses",
	"action.custom_skin_poses.desc": "Load a custom skin pose preset",
	"action.custom_skin_poses.update": "Update Pose",
	"action.custom_skin_poses.update.desc": "Overwrite the saved pose with the current pose of the model",
	"action.add_custom_skin_pose": "Add Custom Skin Pose",
	"action.add_custom_skin_pose.desc": "Save the current pose of the model as a pose preset",
	"action.export_stl": "Export STL",
	"action.export_stl.desc": "Export a STL model for 3D printing",
	"action.add_element": "Add Element",
	"action.add_element.desc": "Add a new element from the list of element types",
	"action.add_spline": "Add Spline",
	"action.add_spline.desc": "Adds a new spline",
	"action.add_billboard": "Add Billboard",
	"action.add_billboard.desc": "Adds a new billboard, a flat element that always faces towards the camera",
	"action.add_armature": "Add Armature",
	"action.add_armature.desc": "Adds an armature that allows deforming a mesh via animation",
	"action.add_armature_bone": "Add Armature Bone",
	"action.add_armature_bone.desc": "Adds a bone to the armature",
	"action.search_textures": "Search Textures",
	"action.search_textures.desc": "Search for textures by name",
	"action.search_animations": "Search Animations",
	"action.search_animations.desc": "Search for animations by name",
	"action.spline_selection_mode": "Spline Selection Mode",
	"action.spline_selection_mode.object": "Object",
	"action.spline_selection_mode.handles": "Handles",
	"action.spline_render_mode": "Geometry",
	"action.spline_render_mode.mesh": "Mesh",
	"action.spline_render_mode.path": "Path",
	"action.spline_render_mode.desc": "Which geometry this spline should render",
	"action.spline_uv_mode": "UV Style",
	"action.spline_uv_mode.length_accurate": "Length Accurate",
	"action.spline_uv_mode.uniform": "Uniform",
	"action.spline_uv_mode.per_segment": "Per Segment",
	"action.spline_uv_mode.desc": "How the spline's tube mesh should lay its UVs",
	"action.spline_ring_segments": "Ring Segments",
	"action.spline_ring_segments.desc": "How many subdivisions this Spline has per Tube Ring",
	"action.spline_tube_segments": "Tube Segments",
	"action.spline_tube_segments.desc": "How many subdivisions this Spline has along its path",
	"action.spline_tube_radius": "Tube Radius",
	"action.spline_tube_radius.desc": "Set the Spline's Tube Radius",
	"action.spline_display_space": "Display Space",
	"action.spline_display_space.desc": "Display spline space indicators on its path",
	"action.spline_handle_mode": "Spline Handle Mode",
	"action.spline_handle_mode.desc": "Which mode to use for transforming spline handles",
	"action.spline_handle_mode.aligned": "Aligned",
	"action.spline_handle_mode.free": "Free",
	"action.spline_handle_mode.mirrored": "Mirrored",
	"action.slider_weight_brush_size": "Weight Brush Size",
	"action.weight_brush_xray": "Weight Brush XRay Mode",
	"action.weight_brush_xray.desc": "When enabled, the weight brush will affect all vertices instead of just the ones that are visible on the surface",
	"action.apply_spline_rotation": "Apply Rotation",
	"action.apply_spline_rotation.desc": "Reset the element rotation of the spline, and apply it to the geometry instead",
	"action.extrude_spline_selection": "Extrude Spline",
	"action.extrude_spline_selection.desc": "Extrude the selected handle on all splines",
	"action.split_spline": "Split Spline",
	"action.split_spline.desc": "Splits the spline into two splines at the selected handle",
	"action.divide_spline_curve": "Divide Spline Segment",
	"action.divide_spline_curve.desc": "Splits the spline segment into two new segments with a new handle at their intersection",
	"action.set_vertex_weights": "Set Vertex Weights",
	"action.set_vertex_weights.desc": "Set the vertex weights of the selected vertices to a specific value on a certain armature bone",
	"action.calculate_vertex_weights": "Calculate Vertex Weights",
	"action.calculate_vertex_weights.desc": "Automatically assign vertex weights weights based on the position of the bones",
	"action.shelf_alignment": "Shelf Alignment",
	"action.shelf_alignment.desc": "Select the vertical alignment of items on the shelf",
	"action.shelf_alignment.top": "Top Alignment",
	"action.shelf_alignment.bottom": "Bottom Alignment",
	"action.view_mode.vertex_weight": "Vertex Weight",
	"action.view_mode.weighted_bone_colors": "Vertex Bone Colors",
	"action.create_animation_group": "Create Animation Group",
	"action.create_animation_group.desc": "Create a group of animations",
	"action.move_graph_keyframes_up": "Move Keyframe Graph Up",
	"action.move_graph_keyframes_down": "Move Keyframe Graph Down",
	"menu.skin": "Skin",
	"menu.text_edit.expression_editor": "Expression Editor",
	"menu.color_picker.picker_type.normal": "Normal Map",
	"menu.texture.flipbook_animation": "Flipbook Animation",
	"menu.panel.attach_to": "Attach To",
	"menu.animation.playing": "Playing",
	"menu.animation_file.save_as": "Save As",
	"menu.animator.quaternion_interpolation": "Quaternion Interpolation",
	"edit.extrude_spline_selection.extend": "Extend",
	"edit.divide_spline_curve.position": "Position",
	"group.bedrock_binding": "Binding",
	"group.cem_attach": "CEM Attach",
	"group.cem_model": "CEM Model",
	"group.cem_scale": "CEM Scale",
	"cube.rescale": "Rotation Rescale",
	"cube.rescale.desc": "Rescale cube to compensate for the rotation angle",
	"mesh.shading": "Shading",
	"mesh.shading.flat": "Flat",
	"mesh.shading.smooth": "Smooth",
	"spline_mesh.cyclic": "Cyclic",
	"spline_mesh.cyclic.desc": "Whether the selected spline should form a loop (Cycle)",
	"billboard.offset": "Offset",
	"billboard.facing_mode": "Facing Mode",
	"billboard.facing_mode.lookat": "Look At",
	"billboard.facing_mode.lookat_y": "Look At Y",
	"billboard.facing_mode.rotate": "Rotate",
	"billboard.facing_mode.rotate_y": "Rotate Y",
	"armature_bone.connected": "Connected",
	"reference_image.blueprint": "Locked Blueprint",
	"codec.image.alpha_channel": "Alpha Channel",
	"codec.image.animation_fps": "Animation FPS",
	"panel.palette": "Palette",
	"panel.keyframe.change_effect_file": "Change Effect File",
	"panel.transform": "Transform",
	"panel.element.spline_dimensions": "Spline Dimensions",
	"display.slot.on_shelf": "Shelf",
	"display.reference.shelf": "Shelf (All Slots)",
	"display.reference.shelf_left": "Shelf (Left Slot)",
	"display.reference.shelf_center": "Shelf (Center Slot)",
	"display.reference.shelf_right": "Shelf (Right Slot)",
	"message.newer_project_format_version.title": "Outdated client",
	"message.newer_project_format_version.message": "This file was saved in a newer version of Blockbench. Update to Blockbench %0 or newer to be able to open it correctly",
	"message.load_images.add_layer": "Add as Layer",
	"message.load_images.category.add_to_project": "Add to project",
	"message.load_images.category.new_project": "New project",
	"message.load_palette.title": "Load Palette",
	"message.load_palette.message": "Are you sure you want to load this palette? This will replace your current color palette.",
	"dialog.set_vertex_weights.weight": "Weight",
	"dialog.set_vertex_weights.overwrite": "Overwrite other bones",
	"action.element_render_order.short": "Render Order",
	"action.element_render_order.desc": "Render order of elements. This can help fix elements that are hidden behind other elements with transparent textures. Leave it on Auto for opaque elements.",
	"spline.shading.flat": "Flat",
	"spline.shading.smooth": "Smooth",
	"spline.shading": "Shading",
	"spline.shading.desc": "How this spline's tube should be shaded",
	"action.slider_weight_brush_limit": "Weight Brush Limit",
	"action.slider_weight_brush_limit.desc": "Set an upper limit for how much weight the weight brush can assign to a vertex",
	"action.weight_brush_blend_mode": "Weight Brush Blend Mode",
	"action.weight_brush_blend_mode.set": "Set",
	"action.weight_brush_blend_mode.add": "Add",
	"action.apply_texture_to_elements": "Apply Texture to Elements",
	"action.apply_texture_to_elements.desc": "Apply the selected texture to the selected elements",
	"menu.panel.reset_size": "Reset Size",
	"action.import_layer": "Import Layer",
	"action.import_layer.desc": "Import image files as layers",
	"menu.collection.open_file": "Open File",
	"layout.version": "Version",
	"settings.status_bar_transform_sliders": "Transform Sliders in Status Bar",
	"settings.status_bar_transform_sliders.desc": "Display the transform sliders toolbar of the selected tool in the status bar instead of using the Transform panel",
	"settings.default_bedrock_format": "Default Bedrock Format",
	"settings.default_bedrock_format.desc": "Select the default format to load Minecraft Bedrock models in, when no specific format can be detected from context.",
	"settings.limit_brush_opacity_per_stroke": "Limit Brush Opacity per Stroke",
	"settings.limit_brush_opacity_per_stroke.desc": "Limit the opacity that a brush can apply to the value of the opacity slider during each brush stroke. With a smooth brush this behavior can potentially lead to slight unwanted noise.",
	"action.merge_splines": "Merge Splines",
	"action.merge_splines.desc": "Merge multiple splines into one",
	"settings.default_java_block_version": "Default Java Block/Item Version",
	"settings.default_java_block_version.desc": "Default format version when creating new Java block/item models or opening files without format version",
	"data.bounding_box": "Bounding Box",
	"keys.option": "Option",
	"keys.slide_lmb_horizontal": "Left-click slide horizontal",
	"keys.slide_lmb_vertical": "Left-click slide vertical",
	"keys.slide_rmb_horizontal": "Right-click slide horizontal",
	"keys.slide_rmb_vertical": "Right-click slide vertical",
	"message.recover_backup.unknown_project": "Unknown project",
	"message.recover_backup.discard_others": "Discard all others",
	"message.unsupported_file_extension.title": "File format not supported",
	"message.unsupported_file_extension.message": "Cannot open file %0, the format is not supported. You might need a plugin for this file type.",
	"message.unsupported_file_extension.open_in_default_program": "Open in default program",
	"dialog.project.uv_size": "UV Size",
	"dialog.collection.offset": "Offset",
	"dialog.texture.fps": "FPS",
	"dialog.texture.fps.desc": "Frames per second of the texture flipbook animation",
	"dialog.edit_uv_size.title": "Edit UV Size",
	"dialog.edit_uv_size.target": "Target",
	"dialog.edit_uv_size.adjust": "Adjust",
	"dialog.edit_uv_size.adjust.adjust_uv": "Counter UV",
	"dialog.edit_uv_size.adjust.adjust_scale": "Counter UV & Scale",
	"dialog.edit_uv_size.adjust.keep": "Keep UV",
	"dialog.edit_uv_size.target_size": "Target UV Size",
	"dialog.edit_uv_size.preset.original": "Original",
	"dialog.edit_uv_size.preset.match_texture": "Match Texture",
	"dialog.edit_uv_size.result": "Result",
	"dialog.edit_uv_size.result.textures": "Textures",
	"dialog.adjust_brightness_contrast.brightness": "Brightness",
	"dialog.adjust_brightness_contrast.contrast": "Contrast",
	"dialog.adjust_saturation_hue.saturation": "Saturation",
	"dialog.adjust_saturation_hue.hue": "Hue",
	"dialog.adjust_opacity.mode": "Mode",
	"dialog.adjust_opacity.mode.multiply": "Multiply",
	"dialog.adjust_opacity.mode.set": "Set",
	"dialog.bedrock_bounding_box.type": "Type",
	"dialog.bedrock_bounding_box.type.collision_box": "Collision",
	"dialog.bedrock_bounding_box.type.selection_box": "Selection Box",
	"dialog.bedrock_bounding_box.type.hitbox": "Hitbox",
	"dialog.bedrock_bounding_box.hitbox_note": "Please note that entity hitboxes only work up to a certain size and may not adapt to the rotation of the entity in-game.",
	"dialog.bedrock_bounding_box.collision_note": "Please note that entity collision boxes only support one centered shape with a square top profile.",
	"dialog.bedrock_bounding_box.no_bounding_boxes": "No bounding boxes exist in this project",
	"dialog.install_plugins_from_list.ids": "Plugin IDs",
	"dialog.install_plugins_from_list.info": "Install several plugins from a list of IDs. Before installing, please ensure that you actually need all plugins. Keeping inactive plugins can increase the risk of bugs and incompatibilities with future updates.",
	"dialog.copy_installed_plugins.details": "Include Details",
	"dialog.flip_animation.phase_offset": "Phase Offset",
	"dialog.flip_animation.phase_offset.off": "Off",
	"dialog.flip_animation.phase_offset.custom": "Custom",
	"dialog.flip_animation.clear_opposite": "Overwrite opposite",
	"settings.flipbook_textures_in_animation": "Play Flipbook Textures in Animation",
	"settings.flipbook_textures_in_animation.desc": "Preview animations on flipbook textures in sync with the animation timeline",
	"settings.display_uv": "Display UV Faces",
	"settings.display_uv.desc": "Select which UV faces are displayed in the UV editor",
	"settings.display_uv.selected_faces": "Only selected faces",
	"settings.display_uv.selected_elements": "All faces on selected elements",
	"settings.display_uv.all_elements": "All faces on all elements",
	"settings.local_position_values": "Local Position Values",
	"settings.local_position_values.desc": "Display all position values in the Transform panel in local space",
	"settings.transform_cube_from_center": "Transform Cubes from Center",
	"settings.transform_cube_from_center.desc": "Edit the cube position values from the center instead of the corner",
	"settings.color_picker_tool_switch": "Color Picker Tool Switch",
	"settings.color_picker_tool_switch.desc": "When picking a transparent pixel, switch to the eraser. When the eraser was previously selected and a color is picked, switch to the brush",
	"keybind.preview_scroll_zoom": "Zoom View",
	"keybind.uv_editor_scroll_zoom": "Zoom UV/2D Editor",
	"action.blend_mode.alpha_mask": "Alpha Mask",
	"action.swap_tools.hold": "Hold to swap (Color Picker)",
	"action.import_bedrock_voxel_shape": "Import Bedrock Voxel Shape",
	"action.import_bedrock_voxel_shape.desc": "Add a voxel shape from a json file to the current project",
	"action.export_bedrock_voxel_shape": "Export Bedrock Voxel Shape",
	"action.export_bedrock_voxel_shape.desc": "Export the bounding boxes in the project as a bedrock voxel shape file",
	"action.plugins_window_menu": "Menu",
	"action.copy_installed_plugins": "Copy Installed Plugins",
	"action.copy_installed_plugins.desc": "Generate and copy a list of the currently installed plugins",
	"action.install_plugins_from_list": "Install Plugins from List",
	"action.install_plugins_from_list.desc": "Install plugins from a list of plugin IDs",
	"action.add_bounding_box": "Add Bounding Box",
	"action.add_bounding_box.desc": "Adds a new bounding box",
	"action.split_alpha_into_layer": "Split Alpha Channel into Layer",
	"action.split_alpha_into_layer.desc": "Split the alpha channel of the texture into an alpha mask layer",
	"action.generate_bedrock_block_box": "Copy Collision/Selection Component",
	"action.generate_bedrock_block_box.desc": "Generate a collision or selection box component for Minecraft Bedrock Edition blocks",
	"action.generate_bedrock_entity_box": "Copy Collision/Hitbox Component",
	"action.generate_bedrock_entity_box.desc": "Generate a collision or custom hit test component for Minecraft Bedrock Edition entities",
	"action.refresh_texture": "Refresh Texture",
	"action.refresh_texture.desc": "Reload the texture from file",
	"action.move_uv_to_cursor": "Move UV to Cursor",
	"action.move_uv_to_cursor.desc": "Move the selected UV faces to the mouse cursor position",
	"action.edit_mode_uv_overlay": "Display All Elements",
	"action.round_keyframe_values": "Round Keyframe Values",
	"action.round_keyframe_values.desc": "Round all values of the selected keyframes",
	"action.keyframe_column_create.all_channels": "All Channels",
	"action.keyframe_column_create.all_channels.desc": "Initialize all channels with keyframes even if they had no keyframes previously",
	"action.add_all_to_timeline": "Add All to Timeline",
	"action.mirror_animating": "Mirror Animating",
	"action.mirror_animating.desc": "Mirror animation edits to the opposite side",
	"action.copy_animation_pose": "Copy Animation Pose",
	"action.copy_animation_pose.desc": "Copy all keyframes to replicate the current animation pose",
	"menu.texture.file_format": "File Format",
	"menu.texture.wrap_mode": "Wrap Mode",
	"menu.texture.wrap_mode.limited": "Restricted",
	"menu.texture.wrap_mode.repeat": "Repeat",
	"menu.texture.wrap_mode.clamp": "Clamp Edge",
	"edit.reparent_selection.adjust_position": "Preserve World Transform",
	"texture_mesh.texture_name": "Texture Name",
	"display.slot.embedded": "Embedded",
	"display.animate_preview": "Preview Animation",
	"display.reference.flower_pot": "Flower Pot"
}